package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Serbia Flag (32x24dp)
 *
 * - ISO Alpha-2: RS
 * - ISO Alpha-3: SRB
 * - ISO Numeric: 688
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.Serbia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Serbia:RS:SRB:688:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF4857A1)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(8f)
                horizontalLineTo(32f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 16f)
                verticalLineTo(24f)
                horizontalLineTo(32f)
                verticalLineTo(16f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6C540)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.456f, 3.803f)
                lineTo(11.343f, 3.35f)
                curveTo(11.439f, 3.379f, 11.544f, 3.41f, 11.655f, 3.441f)
                lineTo(11.653f, 3.435f)
                curveTo(12.974f, 3.555f, 15.014f, 4.238f, 15.394f, 4.964f)
                curveTo(15.541f, 5.245f, 15.395f, 5.484f, 15.203f, 5.797f)
                curveTo(15.175f, 5.844f, 15.145f, 5.892f, 15.115f, 5.943f)
                curveTo(15.019f, 6.106f, 14.932f, 6.262f, 14.85f, 6.409f)
                curveTo(14.553f, 6.939f, 14.322f, 7.353f, 13.97f, 7.565f)
                lineTo(13.977f, 8.766f)
                lineTo(8.082f, 8.716f)
                lineTo(8.074f, 7.502f)
                curveTo(7.773f, 7.277f, 7.557f, 6.891f, 7.287f, 6.409f)
                curveTo(7.205f, 6.262f, 7.118f, 6.106f, 7.022f, 5.943f)
                curveTo(6.992f, 5.892f, 6.962f, 5.844f, 6.934f, 5.797f)
                curveTo(6.743f, 5.484f, 6.597f, 5.245f, 6.743f, 4.964f)
                curveTo(7.029f, 4.418f, 8.323f, 3.888f, 9.508f, 3.607f)
                curveTo(9.742f, 3.524f, 9.986f, 3.447f, 10.227f, 3.372f)
                lineTo(10.335f, 3.45f)
                curveTo(10.429f, 3.438f, 10.52f, 3.427f, 10.607f, 3.419f)
                lineTo(10.743f, 3.722f)
                horizontalLineTo(11.223f)
                curveTo(11.223f, 3.722f, 11.512f, 4.583f, 11.512f, 5.061f)
                curveTo(11.512f, 5.539f, 11.223f, 5.934f, 11.223f, 5.934f)
                verticalLineTo(6.264f)
                curveTo(11.273f, 6.268f, 11.326f, 6.273f, 11.381f, 6.279f)
                curveTo(11.381f, 6.25f, 11.384f, 6.22f, 11.389f, 6.189f)
                curveTo(11.417f, 6.032f, 11.503f, 5.915f, 11.582f, 5.929f)
                curveTo(11.661f, 5.943f, 11.703f, 6.082f, 11.675f, 6.24f)
                curveTo(11.67f, 6.265f, 11.664f, 6.29f, 11.657f, 6.313f)
                curveTo(11.968f, 6.355f, 12.316f, 6.414f, 12.646f, 6.475f)
                curveTo(12.772f, 6.231f, 12.925f, 5.99f, 13.072f, 5.761f)
                curveTo(13.45f, 5.166f, 13.782f, 4.645f, 13.472f, 4.334f)
                curveTo(13.414f, 4.275f, 13.307f, 4.22f, 13.17f, 4.169f)
                curveTo(12.717f, 4.056f, 12.223f, 3.969f, 11.743f, 3.925f)
                lineTo(11.729f, 3.847f)
                curveTo(11.633f, 3.831f, 11.542f, 3.817f, 11.456f, 3.803f)
                close()
                moveTo(13.696f, 6.683f)
                curveTo(13.864f, 6.718f, 13.965f, 6.74f, 13.965f, 6.74f)
                lineTo(13.966f, 6.912f)
                curveTo(14.55f, 6.462f, 14.964f, 5.465f, 15.001f, 5.138f)
                curveTo(15.023f, 4.941f, 14.711f, 4.714f, 14.221f, 4.508f)
                curveTo(14.453f, 4.948f, 14.142f, 5.384f, 13.753f, 5.931f)
                curveTo(13.606f, 6.137f, 13.449f, 6.359f, 13.305f, 6.602f)
                lineTo(13.448f, 6.631f)
                curveTo(13.446f, 6.586f, 13.452f, 6.535f, 13.466f, 6.483f)
                curveTo(13.508f, 6.328f, 13.604f, 6.22f, 13.681f, 6.24f)
                curveTo(13.759f, 6.261f, 13.788f, 6.403f, 13.746f, 6.558f)
                curveTo(13.734f, 6.604f, 13.717f, 6.647f, 13.696f, 6.683f)
                close()
                moveTo(10.684f, 6.266f)
                verticalLineTo(5.898f)
                curveTo(10.684f, 5.898f, 10.433f, 5.618f, 10.394f, 5.034f)
                curveTo(10.366f, 4.616f, 10.452f, 4.125f, 10.503f, 3.879f)
                curveTo(10.129f, 3.926f, 9.734f, 4f, 9.352f, 4.091f)
                curveTo(9.098f, 4.162f, 8.896f, 4.243f, 8.806f, 4.334f)
                curveTo(8.496f, 4.645f, 8.828f, 5.166f, 9.207f, 5.761f)
                lineTo(9.207f, 5.761f)
                lineTo(9.207f, 5.761f)
                lineTo(9.207f, 5.761f)
                curveTo(9.348f, 5.983f, 9.496f, 6.215f, 9.619f, 6.45f)
                curveTo(9.832f, 6.404f, 10.046f, 6.361f, 10.246f, 6.327f)
                curveTo(10.238f, 6.296f, 10.231f, 6.263f, 10.228f, 6.227f)
                curveTo(10.214f, 6.068f, 10.268f, 5.933f, 10.347f, 5.926f)
                curveTo(10.427f, 5.919f, 10.503f, 6.042f, 10.517f, 6.202f)
                curveTo(10.519f, 6.231f, 10.52f, 6.259f, 10.518f, 6.285f)
                curveTo(10.576f, 6.278f, 10.631f, 6.271f, 10.684f, 6.266f)
                close()
                moveTo(8.526f, 5.931f)
                lineTo(8.526f, 5.931f)
                lineTo(8.526f, 5.931f)
                curveTo(8.127f, 5.372f, 7.811f, 4.928f, 8.074f, 4.478f)
                curveTo(7.5f, 4.7f, 7.114f, 4.941f, 7.136f, 5.138f)
                curveTo(7.171f, 5.447f, 7.542f, 6.354f, 8.076f, 6.833f)
                curveTo(8.113f, 6.823f, 8.319f, 6.765f, 8.61f, 6.691f)
                curveTo(8.588f, 6.656f, 8.568f, 6.614f, 8.553f, 6.568f)
                curveTo(8.504f, 6.416f, 8.526f, 6.272f, 8.602f, 6.248f)
                curveTo(8.678f, 6.223f, 8.78f, 6.326f, 8.829f, 6.479f)
                curveTo(8.846f, 6.531f, 8.855f, 6.583f, 8.856f, 6.629f)
                lineTo(8.972f, 6.6f)
                curveTo(8.829f, 6.357f, 8.671f, 6.137f, 8.526f, 5.931f)
                lineTo(8.526f, 5.931f)
                lineTo(8.526f, 5.931f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.652f, 3.506f)
                curveTo(11.652f, 3.857f, 11.36f, 4.142f, 11f, 4.142f)
                curveTo(10.64f, 4.142f, 10.348f, 3.857f, 10.348f, 3.506f)
                curveTo(10.348f, 3.155f, 10.64f, 2.87f, 11f, 2.87f)
                curveTo(11.36f, 2.87f, 11.652f, 3.155f, 11.652f, 3.506f)
                close()
                moveTo(11f, 8.232f)
                curveTo(11.28f, 8.232f, 11.507f, 8.102f, 11.507f, 7.942f)
                curveTo(11.507f, 7.782f, 11.28f, 7.652f, 11f, 7.652f)
                curveTo(10.72f, 7.652f, 10.493f, 7.782f, 10.493f, 7.942f)
                curveTo(10.493f, 8.102f, 10.72f, 8.232f, 11f, 8.232f)
                close()
                moveTo(8.464f, 8.159f)
                curveTo(8.464f, 8.279f, 8.367f, 8.377f, 8.246f, 8.377f)
                curveTo(8.126f, 8.377f, 8.029f, 8.279f, 8.029f, 8.159f)
                curveTo(8.029f, 8.039f, 8.126f, 7.942f, 8.246f, 7.942f)
                curveTo(8.367f, 7.942f, 8.464f, 8.039f, 8.464f, 8.159f)
                close()
                moveTo(14.261f, 8.159f)
                curveTo(14.261f, 8.279f, 14.164f, 8.377f, 14.043f, 8.377f)
                curveTo(13.924f, 8.377f, 13.826f, 8.279f, 13.826f, 8.159f)
                curveTo(13.826f, 8.039f, 13.924f, 7.942f, 14.043f, 7.942f)
                curveTo(14.164f, 7.942f, 14.261f, 8.039f, 14.261f, 8.159f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC5363C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.913f, 8.015f)
                curveTo(9.913f, 8.135f, 9.751f, 8.232f, 9.551f, 8.232f)
                curveTo(9.351f, 8.232f, 9.188f, 8.135f, 9.188f, 8.015f)
                curveTo(9.188f, 7.894f, 9.351f, 7.797f, 9.551f, 7.797f)
                curveTo(9.751f, 7.797f, 9.913f, 7.894f, 9.913f, 8.015f)
                close()
                moveTo(12.957f, 8.015f)
                curveTo(12.957f, 8.135f, 12.794f, 8.232f, 12.594f, 8.232f)
                curveTo(12.394f, 8.232f, 12.232f, 8.135f, 12.232f, 8.015f)
                curveTo(12.232f, 7.894f, 12.394f, 7.797f, 12.594f, 7.797f)
                curveTo(12.794f, 7.797f, 12.957f, 7.894f, 12.957f, 8.015f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.232f, 6.203f)
                curveTo(12.232f, 6.363f, 12.167f, 6.493f, 12.087f, 6.493f)
                curveTo(12.007f, 6.493f, 11.942f, 6.363f, 11.942f, 6.203f)
                curveTo(11.942f, 6.043f, 12.007f, 5.913f, 12.087f, 5.913f)
                curveTo(12.167f, 5.913f, 12.232f, 6.043f, 12.232f, 6.203f)
                close()
                moveTo(10.051f, 6.158f)
                curveTo(10.1f, 6.31f, 10.079f, 6.454f, 10.003f, 6.479f)
                curveTo(9.927f, 6.503f, 9.825f, 6.4f, 9.775f, 6.248f)
                curveTo(9.726f, 6.095f, 9.747f, 5.952f, 9.824f, 5.927f)
                curveTo(9.9f, 5.903f, 10.002f, 6.006f, 10.051f, 6.158f)
                close()
                moveTo(8.346f, 6.944f)
                curveTo(8.422f, 6.919f, 8.444f, 6.776f, 8.394f, 6.624f)
                curveTo(8.345f, 6.471f, 8.243f, 6.368f, 8.167f, 6.393f)
                curveTo(8.091f, 6.417f, 8.069f, 6.561f, 8.119f, 6.713f)
                curveTo(8.168f, 6.865f, 8.27f, 6.969f, 8.346f, 6.944f)
                close()
                moveTo(14.081f, 6.747f)
                curveTo(13.996f, 6.883f, 13.872f, 6.959f, 13.804f, 6.916f)
                curveTo(13.736f, 6.874f, 13.75f, 6.729f, 13.835f, 6.594f)
                curveTo(13.92f, 6.458f, 14.043f, 6.382f, 14.111f, 6.425f)
                curveTo(14.179f, 6.467f, 14.165f, 6.611f, 14.081f, 6.747f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.769f, 3.792f)
                curveTo(9.809f, 3.822f, 9.859f, 3.839f, 9.913f, 3.839f)
                curveTo(10.048f, 3.839f, 10.158f, 3.729f, 10.158f, 3.594f)
                curveTo(10.158f, 3.459f, 10.048f, 3.349f, 9.913f, 3.349f)
                curveTo(9.817f, 3.349f, 9.734f, 3.404f, 9.694f, 3.485f)
                curveTo(9.653f, 3.455f, 9.604f, 3.438f, 9.55f, 3.438f)
                curveTo(9.464f, 3.438f, 9.388f, 3.483f, 9.344f, 3.55f)
                curveTo(9.302f, 3.515f, 9.248f, 3.494f, 9.188f, 3.494f)
                curveTo(9.053f, 3.494f, 8.943f, 3.604f, 8.943f, 3.739f)
                curveTo(8.943f, 3.747f, 8.944f, 3.754f, 8.945f, 3.761f)
                curveTo(8.9f, 3.706f, 8.831f, 3.67f, 8.754f, 3.67f)
                curveTo(8.631f, 3.67f, 8.529f, 3.76f, 8.512f, 3.878f)
                curveTo(8.467f, 3.821f, 8.397f, 3.784f, 8.319f, 3.784f)
                curveTo(8.201f, 3.784f, 8.103f, 3.867f, 8.079f, 3.977f)
                curveTo(8.039f, 3.948f, 7.99f, 3.931f, 7.936f, 3.931f)
                curveTo(7.828f, 3.931f, 7.736f, 4.002f, 7.704f, 4.1f)
                curveTo(7.671f, 4.083f, 7.634f, 4.074f, 7.594f, 4.074f)
                curveTo(7.473f, 4.074f, 7.373f, 4.161f, 7.353f, 4.277f)
                curveTo(7.337f, 4.273f, 7.321f, 4.272f, 7.304f, 4.272f)
                curveTo(7.17f, 4.272f, 7.062f, 4.379f, 7.059f, 4.513f)
                curveTo(7.045f, 4.51f, 7.03f, 4.509f, 7.015f, 4.509f)
                curveTo(6.879f, 4.509f, 6.77f, 4.618f, 6.77f, 4.754f)
                curveTo(6.77f, 4.771f, 6.771f, 4.788f, 6.775f, 4.804f)
                curveTo(6.759f, 4.8f, 6.742f, 4.799f, 6.725f, 4.799f)
                curveTo(6.589f, 4.799f, 6.48f, 4.908f, 6.48f, 5.043f)
                curveTo(6.48f, 5.146f, 6.543f, 5.234f, 6.633f, 5.271f)
                curveTo(6.627f, 5.291f, 6.625f, 5.312f, 6.625f, 5.333f)
                curveTo(6.625f, 5.436f, 6.688f, 5.524f, 6.778f, 5.56f)
                curveTo(6.772f, 5.58f, 6.77f, 5.602f, 6.77f, 5.623f)
                curveTo(6.77f, 5.755f, 6.874f, 5.863f, 7.005f, 5.868f)
                curveTo(6.95f, 5.913f, 6.915f, 5.981f, 6.915f, 6.058f)
                curveTo(6.915f, 6.193f, 7.024f, 6.303f, 7.159f, 6.303f)
                curveTo(7.295f, 6.303f, 7.404f, 6.193f, 7.404f, 6.058f)
                curveTo(7.404f, 5.926f, 7.3f, 5.818f, 7.169f, 5.813f)
                curveTo(7.224f, 5.768f, 7.259f, 5.7f, 7.259f, 5.623f)
                curveTo(7.259f, 5.52f, 7.196f, 5.432f, 7.106f, 5.396f)
                curveTo(7.112f, 5.376f, 7.115f, 5.355f, 7.115f, 5.333f)
                curveTo(7.115f, 5.231f, 7.051f, 5.143f, 6.961f, 5.106f)
                curveTo(6.967f, 5.086f, 6.97f, 5.065f, 6.97f, 5.043f)
                curveTo(6.97f, 5.026f, 6.968f, 5.01f, 6.964f, 4.993f)
                curveTo(6.981f, 4.997f, 6.997f, 4.999f, 7.015f, 4.999f)
                curveTo(7.148f, 4.999f, 7.257f, 4.891f, 7.259f, 4.757f)
                curveTo(7.274f, 4.76f, 7.289f, 4.762f, 7.304f, 4.762f)
                curveTo(7.425f, 4.762f, 7.526f, 4.674f, 7.546f, 4.559f)
                curveTo(7.561f, 4.562f, 7.578f, 4.564f, 7.594f, 4.564f)
                curveTo(7.703f, 4.564f, 7.795f, 4.493f, 7.827f, 4.395f)
                curveTo(7.86f, 4.412f, 7.897f, 4.421f, 7.936f, 4.421f)
                curveTo(7.99f, 4.421f, 8.04f, 4.404f, 8.08f, 4.375f)
                curveTo(8.088f, 4.407f, 8.102f, 4.438f, 8.121f, 4.464f)
                curveTo(8.092f, 4.504f, 8.074f, 4.554f, 8.074f, 4.609f)
                curveTo(8.074f, 4.741f, 8.178f, 4.848f, 8.309f, 4.853f)
                curveTo(8.254f, 4.898f, 8.219f, 4.967f, 8.219f, 5.043f)
                curveTo(8.219f, 5.146f, 8.282f, 5.234f, 8.372f, 5.271f)
                curveTo(8.367f, 5.291f, 8.364f, 5.312f, 8.364f, 5.333f)
                curveTo(8.364f, 5.436f, 8.427f, 5.524f, 8.517f, 5.56f)
                curveTo(8.512f, 5.58f, 8.509f, 5.602f, 8.509f, 5.623f)
                curveTo(8.509f, 5.758f, 8.618f, 5.868f, 8.754f, 5.868f)
                curveTo(8.889f, 5.868f, 8.999f, 5.758f, 8.999f, 5.623f)
                curveTo(8.999f, 5.52f, 8.935f, 5.432f, 8.846f, 5.396f)
                curveTo(8.851f, 5.376f, 8.854f, 5.355f, 8.854f, 5.333f)
                curveTo(8.854f, 5.231f, 8.79f, 5.143f, 8.701f, 5.106f)
                curveTo(8.706f, 5.086f, 8.709f, 5.065f, 8.709f, 5.043f)
                curveTo(8.709f, 4.911f, 8.604f, 4.804f, 8.473f, 4.799f)
                curveTo(8.529f, 4.754f, 8.564f, 4.685f, 8.564f, 4.609f)
                curveTo(8.564f, 4.554f, 8.546f, 4.504f, 8.516f, 4.464f)
                curveTo(8.546f, 4.423f, 8.564f, 4.373f, 8.564f, 4.319f)
                curveTo(8.564f, 4.265f, 8.546f, 4.214f, 8.516f, 4.174f)
                curveTo(8.539f, 4.143f, 8.555f, 4.106f, 8.561f, 4.066f)
                curveTo(8.606f, 4.123f, 8.675f, 4.16f, 8.754f, 4.16f)
                curveTo(8.889f, 4.16f, 8.999f, 4.05f, 8.999f, 3.915f)
                curveTo(8.999f, 3.907f, 8.998f, 3.9f, 8.998f, 3.893f)
                curveTo(9.042f, 3.948f, 9.111f, 3.984f, 9.188f, 3.984f)
                curveTo(9.275f, 3.984f, 9.351f, 3.939f, 9.394f, 3.872f)
                curveTo(9.437f, 3.907f, 9.491f, 3.928f, 9.55f, 3.928f)
                curveTo(9.646f, 3.928f, 9.729f, 3.873f, 9.769f, 3.792f)
                close()
                moveTo(8.319f, 4.274f)
                curveTo(8.4f, 4.274f, 8.472f, 4.235f, 8.516f, 4.174f)
                curveTo(8.472f, 4.113f, 8.4f, 4.074f, 8.319f, 4.074f)
                curveTo(8.344f, 4.074f, 8.364f, 4.054f, 8.364f, 4.029f)
                curveTo(8.364f, 4.004f, 8.344f, 3.984f, 8.319f, 3.984f)
                curveTo(8.294f, 3.984f, 8.274f, 4.004f, 8.274f, 4.029f)
                curveTo(8.274f, 4.054f, 8.294f, 4.074f, 8.319f, 4.074f)
                curveTo(8.265f, 4.074f, 8.215f, 4.091f, 8.175f, 4.121f)
                curveTo(8.161f, 4.062f, 8.127f, 4.011f, 8.079f, 3.977f)
                curveTo(8.076f, 3.994f, 8.074f, 4.011f, 8.074f, 4.029f)
                curveTo(8.074f, 4.083f, 8.092f, 4.133f, 8.121f, 4.174f)
                curveTo(8.092f, 4.214f, 8.074f, 4.265f, 8.074f, 4.319f)
                curveTo(8.074f, 4.338f, 8.076f, 4.357f, 8.08f, 4.375f)
                curveTo(8.128f, 4.34f, 8.163f, 4.288f, 8.176f, 4.228f)
                curveTo(8.216f, 4.257f, 8.266f, 4.274f, 8.319f, 4.274f)
                close()
                moveTo(8.319f, 4.364f)
                curveTo(8.238f, 4.364f, 8.166f, 4.403f, 8.121f, 4.464f)
                curveTo(8.166f, 4.524f, 8.238f, 4.564f, 8.319f, 4.564f)
                curveTo(8.294f, 4.564f, 8.274f, 4.584f, 8.274f, 4.609f)
                curveTo(8.274f, 4.634f, 8.294f, 4.654f, 8.319f, 4.654f)
                curveTo(8.344f, 4.654f, 8.364f, 4.634f, 8.364f, 4.609f)
                curveTo(8.364f, 4.584f, 8.344f, 4.564f, 8.319f, 4.564f)
                curveTo(8.4f, 4.564f, 8.472f, 4.524f, 8.516f, 4.464f)
                curveTo(8.472f, 4.403f, 8.4f, 4.364f, 8.319f, 4.364f)
                close()
                moveTo(8.319f, 4.364f)
                curveTo(8.344f, 4.364f, 8.364f, 4.344f, 8.364f, 4.319f)
                curveTo(8.364f, 4.294f, 8.344f, 4.274f, 8.319f, 4.274f)
                curveTo(8.294f, 4.274f, 8.274f, 4.294f, 8.274f, 4.319f)
                curveTo(8.274f, 4.344f, 8.294f, 4.364f, 8.319f, 4.364f)
                close()
                moveTo(8.176f, 4.228f)
                curveTo(8.155f, 4.213f, 8.137f, 4.195f, 8.121f, 4.174f)
                curveTo(8.136f, 4.153f, 8.155f, 4.135f, 8.175f, 4.121f)
                curveTo(8.179f, 4.138f, 8.181f, 4.157f, 8.181f, 4.176f)
                curveTo(8.181f, 4.194f, 8.18f, 4.211f, 8.176f, 4.228f)
                close()
                moveTo(8.846f, 5.396f)
                curveTo(8.817f, 5.385f, 8.786f, 5.378f, 8.754f, 5.378f)
                curveTo(8.64f, 5.378f, 8.545f, 5.456f, 8.517f, 5.56f)
                curveTo(8.545f, 5.572f, 8.576f, 5.578f, 8.609f, 5.578f)
                curveTo(8.722f, 5.578f, 8.818f, 5.501f, 8.846f, 5.396f)
                close()
                moveTo(8.701f, 5.106f)
                curveTo(8.672f, 5.095f, 8.641f, 5.088f, 8.609f, 5.088f)
                curveTo(8.495f, 5.088f, 8.4f, 5.166f, 8.372f, 5.271f)
                curveTo(8.4f, 5.282f, 8.431f, 5.288f, 8.464f, 5.288f)
                curveTo(8.577f, 5.288f, 8.673f, 5.211f, 8.701f, 5.106f)
                close()
                moveTo(8.473f, 4.799f)
                lineTo(8.464f, 4.799f)
                curveTo(8.405f, 4.799f, 8.351f, 4.819f, 8.309f, 4.853f)
                lineTo(8.319f, 4.854f)
                curveTo(8.377f, 4.854f, 8.431f, 4.833f, 8.473f, 4.799f)
                close()
                moveTo(7.169f, 5.813f)
                lineTo(7.159f, 5.813f)
                curveTo(7.101f, 5.813f, 7.047f, 5.834f, 7.005f, 5.868f)
                lineTo(7.015f, 5.868f)
                curveTo(7.073f, 5.868f, 7.127f, 5.848f, 7.169f, 5.813f)
                close()
                moveTo(7.106f, 5.396f)
                curveTo(7.079f, 5.501f, 6.983f, 5.578f, 6.87f, 5.578f)
                curveTo(6.837f, 5.578f, 6.806f, 5.572f, 6.778f, 5.56f)
                curveTo(6.805f, 5.456f, 6.901f, 5.378f, 7.015f, 5.378f)
                curveTo(7.047f, 5.378f, 7.078f, 5.385f, 7.106f, 5.396f)
                close()
                moveTo(6.961f, 5.106f)
                curveTo(6.934f, 5.211f, 6.838f, 5.288f, 6.725f, 5.288f)
                curveTo(6.692f, 5.288f, 6.661f, 5.282f, 6.633f, 5.271f)
                curveTo(6.66f, 5.166f, 6.756f, 5.088f, 6.87f, 5.088f)
                curveTo(6.902f, 5.088f, 6.933f, 5.095f, 6.961f, 5.106f)
                close()
                moveTo(6.775f, 4.804f)
                curveTo(6.794f, 4.899f, 6.869f, 4.974f, 6.964f, 4.993f)
                curveTo(6.945f, 4.898f, 6.87f, 4.823f, 6.775f, 4.804f)
                close()
                moveTo(7.259f, 4.757f)
                curveTo(7.146f, 4.736f, 7.059f, 4.637f, 7.059f, 4.517f)
                lineTo(7.059f, 4.513f)
                curveTo(7.173f, 4.534f, 7.259f, 4.634f, 7.259f, 4.754f)
                lineTo(7.259f, 4.757f)
                close()
                moveTo(7.546f, 4.559f)
                curveTo(7.434f, 4.536f, 7.349f, 4.437f, 7.349f, 4.319f)
                curveTo(7.349f, 4.304f, 7.351f, 4.29f, 7.353f, 4.277f)
                curveTo(7.465f, 4.299f, 7.549f, 4.398f, 7.549f, 4.517f)
                curveTo(7.549f, 4.531f, 7.548f, 4.545f, 7.546f, 4.559f)
                close()
                moveTo(7.827f, 4.395f)
                curveTo(7.747f, 4.355f, 7.692f, 4.272f, 7.692f, 4.176f)
                curveTo(7.692f, 4.15f, 7.696f, 4.124f, 7.704f, 4.1f)
                curveTo(7.784f, 4.14f, 7.839f, 4.223f, 7.839f, 4.319f)
                curveTo(7.839f, 4.346f, 7.835f, 4.371f, 7.827f, 4.395f)
                close()
                moveTo(8.561f, 4.066f)
                curveTo(8.528f, 4.025f, 8.509f, 3.972f, 8.509f, 3.915f)
                curveTo(8.509f, 3.902f, 8.51f, 3.89f, 8.512f, 3.878f)
                curveTo(8.544f, 3.919f, 8.564f, 3.972f, 8.564f, 4.029f)
                curveTo(8.564f, 4.042f, 8.563f, 4.054f, 8.561f, 4.066f)
                close()
                moveTo(8.945f, 3.761f)
                curveTo(8.949f, 3.811f, 8.968f, 3.856f, 8.998f, 3.893f)
                curveTo(8.993f, 3.843f, 8.974f, 3.798f, 8.945f, 3.761f)
                close()
                moveTo(9.394f, 3.872f)
                curveTo(9.34f, 3.827f, 9.305f, 3.759f, 9.305f, 3.683f)
                curveTo(9.305f, 3.634f, 9.319f, 3.588f, 9.344f, 3.55f)
                curveTo(9.399f, 3.595f, 9.433f, 3.663f, 9.433f, 3.739f)
                curveTo(9.433f, 3.788f, 9.419f, 3.834f, 9.394f, 3.872f)
                close()
                moveTo(9.769f, 3.792f)
                curveTo(9.708f, 3.748f, 9.668f, 3.676f, 9.668f, 3.594f)
                curveTo(9.668f, 3.555f, 9.677f, 3.518f, 9.694f, 3.485f)
                curveTo(9.755f, 3.529f, 9.795f, 3.601f, 9.795f, 3.683f)
                curveTo(9.795f, 3.722f, 9.786f, 3.759f, 9.769f, 3.792f)
                close()
                moveTo(7.304f, 4.562f)
                curveTo(7.329f, 4.562f, 7.349f, 4.541f, 7.349f, 4.517f)
                curveTo(7.349f, 4.492f, 7.329f, 4.472f, 7.304f, 4.472f)
                curveTo(7.28f, 4.472f, 7.259f, 4.492f, 7.259f, 4.517f)
                curveTo(7.259f, 4.541f, 7.28f, 4.562f, 7.304f, 4.562f)
                close()
                moveTo(7.015f, 4.799f)
                curveTo(7.039f, 4.799f, 7.059f, 4.778f, 7.059f, 4.754f)
                curveTo(7.059f, 4.729f, 7.039f, 4.709f, 7.015f, 4.709f)
                curveTo(6.99f, 4.709f, 6.97f, 4.729f, 6.97f, 4.754f)
                curveTo(6.97f, 4.778f, 6.99f, 4.799f, 7.015f, 4.799f)
                close()
                moveTo(6.725f, 5.088f)
                curveTo(6.749f, 5.088f, 6.77f, 5.068f, 6.77f, 5.043f)
                curveTo(6.77f, 5.019f, 6.749f, 4.999f, 6.725f, 4.999f)
                curveTo(6.7f, 4.999f, 6.68f, 5.019f, 6.68f, 5.043f)
                curveTo(6.68f, 5.068f, 6.7f, 5.088f, 6.725f, 5.088f)
                close()
                moveTo(6.87f, 5.378f)
                curveTo(6.894f, 5.378f, 6.915f, 5.358f, 6.915f, 5.333f)
                curveTo(6.915f, 5.309f, 6.894f, 5.288f, 6.87f, 5.288f)
                curveTo(6.845f, 5.288f, 6.825f, 5.309f, 6.825f, 5.333f)
                curveTo(6.825f, 5.358f, 6.845f, 5.378f, 6.87f, 5.378f)
                close()
                moveTo(7.015f, 5.668f)
                curveTo(7.039f, 5.668f, 7.059f, 5.648f, 7.059f, 5.623f)
                curveTo(7.059f, 5.598f, 7.039f, 5.578f, 7.015f, 5.578f)
                curveTo(6.99f, 5.578f, 6.97f, 5.598f, 6.97f, 5.623f)
                curveTo(6.97f, 5.648f, 6.99f, 5.668f, 7.015f, 5.668f)
                close()
                moveTo(7.204f, 6.058f)
                curveTo(7.204f, 6.083f, 7.184f, 6.103f, 7.159f, 6.103f)
                curveTo(7.135f, 6.103f, 7.115f, 6.083f, 7.115f, 6.058f)
                curveTo(7.115f, 6.033f, 7.135f, 6.013f, 7.159f, 6.013f)
                curveTo(7.184f, 6.013f, 7.204f, 6.033f, 7.204f, 6.058f)
                close()
                moveTo(7.594f, 4.364f)
                curveTo(7.619f, 4.364f, 7.639f, 4.344f, 7.639f, 4.319f)
                curveTo(7.639f, 4.294f, 7.619f, 4.274f, 7.594f, 4.274f)
                curveTo(7.569f, 4.274f, 7.549f, 4.294f, 7.549f, 4.319f)
                curveTo(7.549f, 4.344f, 7.569f, 4.364f, 7.594f, 4.364f)
                close()
                moveTo(7.936f, 4.221f)
                curveTo(7.961f, 4.221f, 7.981f, 4.201f, 7.981f, 4.176f)
                curveTo(7.981f, 4.151f, 7.961f, 4.131f, 7.936f, 4.131f)
                curveTo(7.912f, 4.131f, 7.892f, 4.151f, 7.892f, 4.176f)
                curveTo(7.892f, 4.201f, 7.912f, 4.221f, 7.936f, 4.221f)
                close()
                moveTo(8.754f, 3.96f)
                curveTo(8.778f, 3.96f, 8.799f, 3.94f, 8.799f, 3.915f)
                curveTo(8.799f, 3.89f, 8.778f, 3.87f, 8.754f, 3.87f)
                curveTo(8.729f, 3.87f, 8.709f, 3.89f, 8.709f, 3.915f)
                curveTo(8.709f, 3.94f, 8.729f, 3.96f, 8.754f, 3.96f)
                close()
                moveTo(9.188f, 3.784f)
                curveTo(9.213f, 3.784f, 9.233f, 3.764f, 9.233f, 3.739f)
                curveTo(9.233f, 3.714f, 9.213f, 3.694f, 9.188f, 3.694f)
                curveTo(9.164f, 3.694f, 9.144f, 3.714f, 9.144f, 3.739f)
                curveTo(9.144f, 3.764f, 9.164f, 3.784f, 9.188f, 3.784f)
                close()
                moveTo(9.55f, 3.728f)
                curveTo(9.575f, 3.728f, 9.595f, 3.708f, 9.595f, 3.683f)
                curveTo(9.595f, 3.658f, 9.575f, 3.638f, 9.55f, 3.638f)
                curveTo(9.525f, 3.638f, 9.505f, 3.658f, 9.505f, 3.683f)
                curveTo(9.505f, 3.708f, 9.525f, 3.728f, 9.55f, 3.728f)
                close()
                moveTo(9.913f, 3.639f)
                curveTo(9.938f, 3.639f, 9.958f, 3.619f, 9.958f, 3.594f)
                curveTo(9.958f, 3.569f, 9.938f, 3.549f, 9.913f, 3.549f)
                curveTo(9.888f, 3.549f, 9.868f, 3.569f, 9.868f, 3.594f)
                curveTo(9.868f, 3.619f, 9.888f, 3.639f, 9.913f, 3.639f)
                close()
                moveTo(8.464f, 5.088f)
                curveTo(8.489f, 5.088f, 8.509f, 5.068f, 8.509f, 5.043f)
                curveTo(8.509f, 5.019f, 8.489f, 4.999f, 8.464f, 4.999f)
                curveTo(8.439f, 4.999f, 8.419f, 5.019f, 8.419f, 5.043f)
                curveTo(8.419f, 5.068f, 8.439f, 5.088f, 8.464f, 5.088f)
                close()
                moveTo(8.609f, 5.378f)
                curveTo(8.634f, 5.378f, 8.654f, 5.358f, 8.654f, 5.333f)
                curveTo(8.654f, 5.309f, 8.634f, 5.288f, 8.609f, 5.288f)
                curveTo(8.584f, 5.288f, 8.564f, 5.309f, 8.564f, 5.333f)
                curveTo(8.564f, 5.358f, 8.584f, 5.378f, 8.609f, 5.378f)
                close()
                moveTo(8.754f, 5.668f)
                curveTo(8.778f, 5.668f, 8.799f, 5.648f, 8.799f, 5.623f)
                curveTo(8.799f, 5.598f, 8.778f, 5.578f, 8.754f, 5.578f)
                curveTo(8.729f, 5.578f, 8.709f, 5.598f, 8.709f, 5.623f)
                curveTo(8.709f, 5.648f, 8.729f, 5.668f, 8.754f, 5.668f)
                close()
                moveTo(15.13f, 6.103f)
                curveTo(15.155f, 6.103f, 15.175f, 6.083f, 15.175f, 6.058f)
                curveTo(15.175f, 6.033f, 15.155f, 6.013f, 15.13f, 6.013f)
                curveTo(15.106f, 6.013f, 15.085f, 6.033f, 15.085f, 6.058f)
                curveTo(15.085f, 6.083f, 15.106f, 6.103f, 15.13f, 6.103f)
                close()
                moveTo(14.885f, 6.058f)
                curveTo(14.885f, 6.193f, 14.995f, 6.303f, 15.13f, 6.303f)
                curveTo(15.266f, 6.303f, 15.375f, 6.193f, 15.375f, 6.058f)
                curveTo(15.375f, 5.981f, 15.34f, 5.913f, 15.285f, 5.868f)
                curveTo(15.416f, 5.863f, 15.52f, 5.755f, 15.52f, 5.623f)
                curveTo(15.52f, 5.602f, 15.517f, 5.58f, 15.512f, 5.56f)
                curveTo(15.602f, 5.524f, 15.665f, 5.436f, 15.665f, 5.333f)
                curveTo(15.665f, 5.312f, 15.662f, 5.291f, 15.657f, 5.271f)
                curveTo(15.747f, 5.234f, 15.81f, 5.146f, 15.81f, 5.043f)
                curveTo(15.81f, 4.908f, 15.7f, 4.799f, 15.565f, 4.799f)
                curveTo(15.548f, 4.799f, 15.531f, 4.8f, 15.515f, 4.804f)
                curveTo(15.519f, 4.788f, 15.52f, 4.771f, 15.52f, 4.754f)
                curveTo(15.52f, 4.618f, 15.411f, 4.509f, 15.275f, 4.509f)
                curveTo(15.26f, 4.509f, 15.245f, 4.51f, 15.23f, 4.513f)
                curveTo(15.228f, 4.379f, 15.12f, 4.272f, 14.986f, 4.272f)
                curveTo(14.969f, 4.272f, 14.953f, 4.273f, 14.937f, 4.277f)
                curveTo(14.917f, 4.161f, 14.816f, 4.074f, 14.696f, 4.074f)
                curveTo(14.656f, 4.074f, 14.619f, 4.083f, 14.586f, 4.1f)
                curveTo(14.554f, 4.002f, 14.462f, 3.931f, 14.353f, 3.931f)
                curveTo(14.3f, 3.931f, 14.251f, 3.948f, 14.21f, 3.977f)
                curveTo(14.187f, 3.867f, 14.089f, 3.784f, 13.971f, 3.784f)
                curveTo(13.893f, 3.784f, 13.823f, 3.821f, 13.778f, 3.878f)
                curveTo(13.76f, 3.76f, 13.659f, 3.67f, 13.536f, 3.67f)
                curveTo(13.459f, 3.67f, 13.39f, 3.706f, 13.345f, 3.761f)
                curveTo(13.346f, 3.754f, 13.346f, 3.747f, 13.346f, 3.739f)
                curveTo(13.346f, 3.604f, 13.237f, 3.494f, 13.101f, 3.494f)
                curveTo(13.042f, 3.494f, 12.988f, 3.515f, 12.946f, 3.55f)
                curveTo(12.902f, 3.483f, 12.826f, 3.438f, 12.74f, 3.438f)
                curveTo(12.686f, 3.438f, 12.636f, 3.455f, 12.596f, 3.485f)
                curveTo(12.556f, 3.404f, 12.473f, 3.349f, 12.377f, 3.349f)
                curveTo(12.242f, 3.349f, 12.132f, 3.459f, 12.132f, 3.594f)
                curveTo(12.132f, 3.729f, 12.242f, 3.839f, 12.377f, 3.839f)
                curveTo(12.431f, 3.839f, 12.48f, 3.822f, 12.521f, 3.792f)
                curveTo(12.561f, 3.873f, 12.644f, 3.928f, 12.74f, 3.928f)
                curveTo(12.799f, 3.928f, 12.853f, 3.907f, 12.896f, 3.872f)
                curveTo(12.939f, 3.939f, 13.015f, 3.984f, 13.101f, 3.984f)
                curveTo(13.179f, 3.984f, 13.247f, 3.948f, 13.292f, 3.893f)
                curveTo(13.292f, 3.9f, 13.291f, 3.907f, 13.291f, 3.915f)
                curveTo(13.291f, 4.05f, 13.401f, 4.16f, 13.536f, 4.16f)
                curveTo(13.615f, 4.16f, 13.684f, 4.123f, 13.729f, 4.066f)
                curveTo(13.735f, 4.106f, 13.751f, 4.143f, 13.774f, 4.174f)
                curveTo(13.744f, 4.214f, 13.726f, 4.265f, 13.726f, 4.319f)
                curveTo(13.726f, 4.373f, 13.744f, 4.423f, 13.774f, 4.464f)
                curveTo(13.744f, 4.504f, 13.726f, 4.554f, 13.726f, 4.609f)
                curveTo(13.726f, 4.685f, 13.761f, 4.754f, 13.816f, 4.799f)
                curveTo(13.686f, 4.804f, 13.581f, 4.911f, 13.581f, 5.043f)
                curveTo(13.581f, 5.065f, 13.584f, 5.086f, 13.589f, 5.106f)
                curveTo(13.5f, 5.143f, 13.436f, 5.231f, 13.436f, 5.333f)
                curveTo(13.436f, 5.355f, 13.439f, 5.376f, 13.444f, 5.396f)
                curveTo(13.355f, 5.432f, 13.291f, 5.52f, 13.291f, 5.623f)
                curveTo(13.291f, 5.758f, 13.401f, 5.868f, 13.536f, 5.868f)
                curveTo(13.672f, 5.868f, 13.781f, 5.758f, 13.781f, 5.623f)
                curveTo(13.781f, 5.602f, 13.778f, 5.58f, 13.773f, 5.56f)
                curveTo(13.863f, 5.524f, 13.926f, 5.436f, 13.926f, 5.333f)
                curveTo(13.926f, 5.312f, 13.923f, 5.291f, 13.918f, 5.271f)
                curveTo(14.008f, 5.234f, 14.071f, 5.146f, 14.071f, 5.043f)
                curveTo(14.071f, 4.967f, 14.036f, 4.898f, 13.981f, 4.853f)
                curveTo(14.111f, 4.848f, 14.216f, 4.741f, 14.216f, 4.609f)
                curveTo(14.216f, 4.554f, 14.198f, 4.504f, 14.168f, 4.464f)
                curveTo(14.188f, 4.438f, 14.202f, 4.407f, 14.21f, 4.375f)
                curveTo(14.25f, 4.404f, 14.3f, 4.421f, 14.353f, 4.421f)
                curveTo(14.393f, 4.421f, 14.43f, 4.412f, 14.463f, 4.395f)
                curveTo(14.495f, 4.493f, 14.587f, 4.564f, 14.696f, 4.564f)
                curveTo(14.712f, 4.564f, 14.729f, 4.562f, 14.744f, 4.559f)
                curveTo(14.764f, 4.674f, 14.865f, 4.762f, 14.986f, 4.762f)
                curveTo(15.001f, 4.762f, 15.016f, 4.76f, 15.031f, 4.757f)
                curveTo(15.033f, 4.891f, 15.141f, 4.999f, 15.275f, 4.999f)
                curveTo(15.292f, 4.999f, 15.309f, 4.997f, 15.325f, 4.993f)
                curveTo(15.322f, 5.01f, 15.32f, 5.026f, 15.32f, 5.043f)
                curveTo(15.32f, 5.065f, 15.323f, 5.086f, 15.328f, 5.106f)
                curveTo(15.239f, 5.143f, 15.175f, 5.231f, 15.175f, 5.333f)
                curveTo(15.175f, 5.355f, 15.178f, 5.376f, 15.184f, 5.396f)
                curveTo(15.094f, 5.432f, 15.031f, 5.52f, 15.031f, 5.623f)
                curveTo(15.031f, 5.7f, 15.066f, 5.768f, 15.121f, 5.813f)
                curveTo(14.99f, 5.818f, 14.885f, 5.926f, 14.885f, 6.058f)
                close()
                moveTo(14.114f, 4.228f)
                curveTo(14.127f, 4.288f, 14.162f, 4.34f, 14.21f, 4.375f)
                curveTo(14.214f, 4.357f, 14.216f, 4.338f, 14.216f, 4.319f)
                curveTo(14.216f, 4.265f, 14.198f, 4.214f, 14.168f, 4.174f)
                curveTo(14.198f, 4.133f, 14.216f, 4.083f, 14.216f, 4.029f)
                curveTo(14.216f, 4.011f, 14.214f, 3.994f, 14.21f, 3.977f)
                curveTo(14.163f, 4.011f, 14.128f, 4.062f, 14.115f, 4.121f)
                curveTo(14.075f, 4.091f, 14.025f, 4.074f, 13.971f, 4.074f)
                curveTo(13.996f, 4.074f, 14.016f, 4.054f, 14.016f, 4.029f)
                curveTo(14.016f, 4.004f, 13.996f, 3.984f, 13.971f, 3.984f)
                curveTo(13.946f, 3.984f, 13.926f, 4.004f, 13.926f, 4.029f)
                curveTo(13.926f, 4.054f, 13.946f, 4.074f, 13.971f, 4.074f)
                curveTo(13.89f, 4.074f, 13.818f, 4.113f, 13.774f, 4.174f)
                curveTo(13.818f, 4.235f, 13.89f, 4.274f, 13.971f, 4.274f)
                curveTo(13.946f, 4.274f, 13.926f, 4.294f, 13.926f, 4.319f)
                curveTo(13.926f, 4.344f, 13.946f, 4.364f, 13.971f, 4.364f)
                curveTo(13.89f, 4.364f, 13.818f, 4.403f, 13.774f, 4.464f)
                curveTo(13.818f, 4.524f, 13.89f, 4.564f, 13.971f, 4.564f)
                curveTo(13.946f, 4.564f, 13.926f, 4.584f, 13.926f, 4.609f)
                curveTo(13.926f, 4.634f, 13.946f, 4.654f, 13.971f, 4.654f)
                curveTo(13.996f, 4.654f, 14.016f, 4.634f, 14.016f, 4.609f)
                curveTo(14.016f, 4.584f, 13.996f, 4.564f, 13.971f, 4.564f)
                curveTo(14.052f, 4.564f, 14.124f, 4.524f, 14.168f, 4.464f)
                curveTo(14.124f, 4.403f, 14.052f, 4.364f, 13.971f, 4.364f)
                curveTo(13.996f, 4.364f, 14.016f, 4.344f, 14.016f, 4.319f)
                curveTo(14.016f, 4.294f, 13.996f, 4.274f, 13.971f, 4.274f)
                curveTo(14.024f, 4.274f, 14.074f, 4.257f, 14.114f, 4.228f)
                close()
                moveTo(14.114f, 4.228f)
                curveTo(14.135f, 4.213f, 14.153f, 4.195f, 14.168f, 4.174f)
                curveTo(14.153f, 4.153f, 14.135f, 4.135f, 14.115f, 4.121f)
                curveTo(14.111f, 4.138f, 14.108f, 4.157f, 14.108f, 4.176f)
                curveTo(14.108f, 4.194f, 14.11f, 4.211f, 14.114f, 4.228f)
                close()
                moveTo(13.773f, 5.56f)
                curveTo(13.745f, 5.456f, 13.65f, 5.378f, 13.536f, 5.378f)
                curveTo(13.504f, 5.378f, 13.473f, 5.385f, 13.444f, 5.396f)
                curveTo(13.472f, 5.501f, 13.568f, 5.578f, 13.681f, 5.578f)
                curveTo(13.714f, 5.578f, 13.745f, 5.572f, 13.773f, 5.56f)
                close()
                moveTo(13.918f, 5.271f)
                curveTo(13.89f, 5.166f, 13.795f, 5.088f, 13.681f, 5.088f)
                curveTo(13.649f, 5.088f, 13.618f, 5.095f, 13.589f, 5.106f)
                curveTo(13.617f, 5.211f, 13.712f, 5.288f, 13.826f, 5.288f)
                curveTo(13.859f, 5.288f, 13.89f, 5.282f, 13.918f, 5.271f)
                close()
                moveTo(13.981f, 4.853f)
                curveTo(13.939f, 4.819f, 13.885f, 4.799f, 13.826f, 4.799f)
                lineTo(13.816f, 4.799f)
                curveTo(13.859f, 4.833f, 13.913f, 4.854f, 13.971f, 4.854f)
                lineTo(13.981f, 4.853f)
                close()
                moveTo(12.521f, 3.792f)
                curveTo(12.582f, 3.748f, 12.622f, 3.676f, 12.622f, 3.594f)
                curveTo(12.622f, 3.555f, 12.613f, 3.518f, 12.596f, 3.485f)
                curveTo(12.535f, 3.529f, 12.495f, 3.601f, 12.495f, 3.683f)
                curveTo(12.495f, 3.722f, 12.504f, 3.759f, 12.521f, 3.792f)
                close()
                moveTo(12.896f, 3.872f)
                curveTo(12.95f, 3.827f, 12.985f, 3.759f, 12.985f, 3.683f)
                curveTo(12.985f, 3.634f, 12.971f, 3.588f, 12.946f, 3.55f)
                curveTo(12.891f, 3.595f, 12.856f, 3.663f, 12.856f, 3.739f)
                curveTo(12.856f, 3.788f, 12.871f, 3.834f, 12.896f, 3.872f)
                close()
                moveTo(13.345f, 3.761f)
                curveTo(13.341f, 3.811f, 13.322f, 3.856f, 13.292f, 3.893f)
                curveTo(13.297f, 3.843f, 13.316f, 3.798f, 13.345f, 3.761f)
                close()
                moveTo(13.729f, 4.066f)
                curveTo(13.762f, 4.025f, 13.781f, 3.972f, 13.781f, 3.915f)
                curveTo(13.781f, 3.902f, 13.78f, 3.89f, 13.778f, 3.878f)
                curveTo(13.746f, 3.919f, 13.726f, 3.972f, 13.726f, 4.029f)
                curveTo(13.726f, 4.042f, 13.727f, 4.054f, 13.729f, 4.066f)
                close()
                moveTo(14.463f, 4.395f)
                curveTo(14.543f, 4.355f, 14.598f, 4.272f, 14.598f, 4.176f)
                curveTo(14.598f, 4.15f, 14.594f, 4.124f, 14.586f, 4.1f)
                curveTo(14.506f, 4.14f, 14.451f, 4.223f, 14.451f, 4.319f)
                curveTo(14.451f, 4.346f, 14.455f, 4.371f, 14.463f, 4.395f)
                close()
                moveTo(14.744f, 4.559f)
                curveTo(14.856f, 4.536f, 14.941f, 4.437f, 14.941f, 4.319f)
                curveTo(14.941f, 4.304f, 14.939f, 4.29f, 14.937f, 4.277f)
                curveTo(14.825f, 4.299f, 14.741f, 4.398f, 14.741f, 4.517f)
                curveTo(14.741f, 4.531f, 14.742f, 4.545f, 14.744f, 4.559f)
                close()
                moveTo(15.325f, 4.993f)
                curveTo(15.42f, 4.974f, 15.495f, 4.899f, 15.515f, 4.804f)
                curveTo(15.42f, 4.823f, 15.345f, 4.898f, 15.325f, 4.993f)
                close()
                moveTo(15.23f, 4.513f)
                lineTo(15.231f, 4.517f)
                curveTo(15.231f, 4.637f, 15.144f, 4.736f, 15.031f, 4.757f)
                lineTo(15.031f, 4.754f)
                curveTo(15.031f, 4.634f, 15.117f, 4.534f, 15.23f, 4.513f)
                close()
                moveTo(15.328f, 5.106f)
                curveTo(15.357f, 5.095f, 15.388f, 5.088f, 15.42f, 5.088f)
                curveTo(15.534f, 5.088f, 15.629f, 5.166f, 15.657f, 5.271f)
                curveTo(15.629f, 5.282f, 15.598f, 5.288f, 15.565f, 5.288f)
                curveTo(15.452f, 5.288f, 15.356f, 5.211f, 15.328f, 5.106f)
                close()
                moveTo(15.184f, 5.396f)
                curveTo(15.212f, 5.385f, 15.243f, 5.378f, 15.275f, 5.378f)
                curveTo(15.389f, 5.378f, 15.484f, 5.456f, 15.512f, 5.56f)
                curveTo(15.484f, 5.572f, 15.453f, 5.578f, 15.42f, 5.578f)
                curveTo(15.307f, 5.578f, 15.211f, 5.501f, 15.184f, 5.396f)
                close()
                moveTo(15.275f, 5.868f)
                curveTo(15.217f, 5.868f, 15.163f, 5.848f, 15.121f, 5.813f)
                lineTo(15.13f, 5.813f)
                curveTo(15.189f, 5.813f, 15.243f, 5.834f, 15.285f, 5.868f)
                lineTo(15.275f, 5.868f)
                close()
                moveTo(15.275f, 5.668f)
                curveTo(15.3f, 5.668f, 15.32f, 5.648f, 15.32f, 5.623f)
                curveTo(15.32f, 5.598f, 15.3f, 5.578f, 15.275f, 5.578f)
                curveTo(15.251f, 5.578f, 15.231f, 5.598f, 15.231f, 5.623f)
                curveTo(15.231f, 5.648f, 15.251f, 5.668f, 15.275f, 5.668f)
                close()
                moveTo(15.42f, 5.378f)
                curveTo(15.445f, 5.378f, 15.465f, 5.358f, 15.465f, 5.333f)
                curveTo(15.465f, 5.309f, 15.445f, 5.288f, 15.42f, 5.288f)
                curveTo(15.396f, 5.288f, 15.375f, 5.309f, 15.375f, 5.333f)
                curveTo(15.375f, 5.358f, 15.396f, 5.378f, 15.42f, 5.378f)
                close()
                moveTo(15.565f, 5.088f)
                curveTo(15.59f, 5.088f, 15.61f, 5.068f, 15.61f, 5.043f)
                curveTo(15.61f, 5.019f, 15.59f, 4.999f, 15.565f, 4.999f)
                curveTo(15.54f, 4.999f, 15.52f, 5.019f, 15.52f, 5.043f)
                curveTo(15.52f, 5.068f, 15.54f, 5.088f, 15.565f, 5.088f)
                close()
                moveTo(15.275f, 4.799f)
                curveTo(15.3f, 4.799f, 15.32f, 4.778f, 15.32f, 4.754f)
                curveTo(15.32f, 4.729f, 15.3f, 4.709f, 15.275f, 4.709f)
                curveTo(15.251f, 4.709f, 15.231f, 4.729f, 15.231f, 4.754f)
                curveTo(15.231f, 4.778f, 15.251f, 4.799f, 15.275f, 4.799f)
                close()
                moveTo(14.986f, 4.562f)
                curveTo(15.01f, 4.562f, 15.031f, 4.541f, 15.031f, 4.517f)
                curveTo(15.031f, 4.492f, 15.01f, 4.472f, 14.986f, 4.472f)
                curveTo(14.961f, 4.472f, 14.941f, 4.492f, 14.941f, 4.517f)
                curveTo(14.941f, 4.541f, 14.961f, 4.562f, 14.986f, 4.562f)
                close()
                moveTo(14.696f, 4.364f)
                curveTo(14.72f, 4.364f, 14.741f, 4.344f, 14.741f, 4.319f)
                curveTo(14.741f, 4.294f, 14.72f, 4.274f, 14.696f, 4.274f)
                curveTo(14.671f, 4.274f, 14.651f, 4.294f, 14.651f, 4.319f)
                curveTo(14.651f, 4.344f, 14.671f, 4.364f, 14.696f, 4.364f)
                close()
                moveTo(14.353f, 4.221f)
                curveTo(14.378f, 4.221f, 14.398f, 4.201f, 14.398f, 4.176f)
                curveTo(14.398f, 4.151f, 14.378f, 4.131f, 14.353f, 4.131f)
                curveTo(14.329f, 4.131f, 14.309f, 4.151f, 14.309f, 4.176f)
                curveTo(14.309f, 4.201f, 14.329f, 4.221f, 14.353f, 4.221f)
                close()
                moveTo(13.536f, 3.96f)
                curveTo(13.561f, 3.96f, 13.581f, 3.94f, 13.581f, 3.915f)
                curveTo(13.581f, 3.89f, 13.561f, 3.87f, 13.536f, 3.87f)
                curveTo(13.511f, 3.87f, 13.491f, 3.89f, 13.491f, 3.915f)
                curveTo(13.491f, 3.94f, 13.511f, 3.96f, 13.536f, 3.96f)
                close()
                moveTo(13.101f, 3.784f)
                curveTo(13.126f, 3.784f, 13.146f, 3.764f, 13.146f, 3.739f)
                curveTo(13.146f, 3.714f, 13.126f, 3.694f, 13.101f, 3.694f)
                curveTo(13.077f, 3.694f, 13.057f, 3.714f, 13.057f, 3.739f)
                curveTo(13.057f, 3.764f, 13.077f, 3.784f, 13.101f, 3.784f)
                close()
                moveTo(12.74f, 3.728f)
                curveTo(12.765f, 3.728f, 12.785f, 3.708f, 12.785f, 3.683f)
                curveTo(12.785f, 3.658f, 12.765f, 3.638f, 12.74f, 3.638f)
                curveTo(12.715f, 3.638f, 12.695f, 3.658f, 12.695f, 3.683f)
                curveTo(12.695f, 3.708f, 12.715f, 3.728f, 12.74f, 3.728f)
                close()
                moveTo(12.377f, 3.639f)
                curveTo(12.402f, 3.639f, 12.422f, 3.619f, 12.422f, 3.594f)
                curveTo(12.422f, 3.569f, 12.402f, 3.549f, 12.377f, 3.549f)
                curveTo(12.352f, 3.549f, 12.332f, 3.569f, 12.332f, 3.594f)
                curveTo(12.332f, 3.619f, 12.352f, 3.639f, 12.377f, 3.639f)
                close()
                moveTo(13.826f, 5.088f)
                curveTo(13.851f, 5.088f, 13.871f, 5.068f, 13.871f, 5.043f)
                curveTo(13.871f, 5.019f, 13.851f, 4.999f, 13.826f, 4.999f)
                curveTo(13.801f, 4.999f, 13.781f, 5.019f, 13.781f, 5.043f)
                curveTo(13.781f, 5.068f, 13.801f, 5.088f, 13.826f, 5.088f)
                close()
                moveTo(13.681f, 5.378f)
                curveTo(13.706f, 5.378f, 13.726f, 5.358f, 13.726f, 5.333f)
                curveTo(13.726f, 5.309f, 13.706f, 5.288f, 13.681f, 5.288f)
                curveTo(13.656f, 5.288f, 13.636f, 5.309f, 13.636f, 5.333f)
                curveTo(13.636f, 5.358f, 13.656f, 5.378f, 13.681f, 5.378f)
                close()
                moveTo(13.536f, 5.668f)
                curveTo(13.561f, 5.668f, 13.581f, 5.648f, 13.581f, 5.623f)
                curveTo(13.581f, 5.598f, 13.561f, 5.578f, 13.536f, 5.578f)
                curveTo(13.511f, 5.578f, 13.491f, 5.598f, 13.491f, 5.623f)
                curveTo(13.491f, 5.648f, 13.511f, 5.668f, 13.536f, 5.668f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF6C540)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.102f, 2.154f)
                lineTo(10.887f, 2.158f)
                lineTo(10.887f, 2.511f)
                lineTo(10.491f, 2.511f)
                lineTo(10.495f, 2.725f)
                lineTo(10.887f, 2.725f)
                lineTo(10.888f, 3.128f)
                lineTo(11.103f, 3.124f)
                lineTo(11.102f, 2.725f)
                lineTo(11.492f, 2.725f)
                lineTo(11.488f, 2.511f)
                lineTo(11.102f, 2.511f)
                lineTo(11.102f, 2.154f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5.785f, 8.734f)
                horizontalLineTo(16.185f)
                verticalLineTo(17.568f)
                curveTo(16.185f, 17.568f, 15.87f, 21.968f, 10.985f, 21.968f)
                curveTo(6.099f, 21.968f, 5.785f, 17.568f, 5.785f, 17.568f)
                verticalLineTo(8.734f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.924f, 9.04f)
                curveTo(8.828f, 9.04f, 8.681f, 9.108f, 8.487f, 9.186f)
                curveTo(8.292f, 9.263f, 8.088f, 9.431f, 8.287f, 9.599f)
                curveTo(8.487f, 9.766f, 8.772f, 10.134f, 8.772f, 9.997f)
                curveTo(8.772f, 9.859f, 9.114f, 9.726f, 9.114f, 9.792f)
                curveTo(9.114f, 9.859f, 9.008f, 9.997f, 9.285f, 9.997f)
                curveTo(9.562f, 9.997f, 9.705f, 10.079f, 9.409f, 10.079f)
                curveTo(9.114f, 10.079f, 9.081f, 10.214f, 8.889f, 10.214f)
                curveTo(8.697f, 10.214f, 8.287f, 10.078f, 8.287f, 9.997f)
                curveTo(8.287f, 9.916f, 8.525f, 10.394f, 8.772f, 10.394f)
                curveTo(9.02f, 10.394f, 9.161f, 10.627f, 9.285f, 10.51f)
                curveTo(9.409f, 10.394f, 9.394f, 10.394f, 9.595f, 10.394f)
                curveTo(9.796f, 10.394f, 9.722f, 9.924f, 9.722f, 9.924f)
                curveTo(9.722f, 9.924f, 9.019f, 9.04f, 8.924f, 9.04f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.937f, 9.04f)
                curveTo(13.032f, 9.04f, 13.179f, 9.108f, 13.374f, 9.186f)
                curveTo(13.568f, 9.263f, 13.773f, 9.431f, 13.573f, 9.599f)
                curveTo(13.374f, 9.766f, 13.088f, 10.134f, 13.088f, 9.997f)
                curveTo(13.088f, 9.859f, 12.747f, 9.726f, 12.747f, 9.792f)
                curveTo(12.747f, 9.859f, 12.853f, 9.997f, 12.576f, 9.997f)
                curveTo(12.299f, 9.997f, 12.156f, 10.079f, 12.451f, 10.079f)
                curveTo(12.747f, 10.079f, 12.779f, 10.214f, 12.971f, 10.214f)
                curveTo(13.163f, 10.214f, 13.573f, 10.078f, 13.573f, 9.997f)
                curveTo(13.573f, 9.916f, 13.336f, 10.394f, 13.088f, 10.394f)
                curveTo(12.841f, 10.394f, 12.7f, 10.627f, 12.576f, 10.51f)
                curveTo(12.451f, 10.394f, 12.466f, 10.394f, 12.266f, 10.394f)
                curveTo(12.065f, 10.394f, 12.138f, 9.924f, 12.138f, 9.924f)
                curveTo(12.138f, 9.924f, 12.842f, 9.04f, 12.937f, 9.04f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(14.212f, 10f)
                curveTo(14.411f, 10.465f, 12.883f, 12.192f, 12.883f, 12.192f)
                horizontalLineTo(12.712f)
                curveTo(12.641f, 12.192f, 12.507f, 12.015f, 12.345f, 11.802f)
                curveTo(12.235f, 11.655f, 12.111f, 11.492f, 11.985f, 11.356f)
                curveTo(11.749f, 11.101f, 11.874f, 10.886f, 11.991f, 10.686f)
                curveTo(12.027f, 10.625f, 12.062f, 10.565f, 12.085f, 10.505f)
                curveTo(12.137f, 10.377f, 12.144f, 10.325f, 12.152f, 10.266f)
                curveTo(12.16f, 10.21f, 12.169f, 10.146f, 12.219f, 10f)
                curveTo(12.293f, 9.785f, 12.55f, 9.508f, 12.727f, 9.316f)
                curveTo(12.796f, 9.242f, 12.853f, 9.18f, 12.883f, 9.14f)
                curveTo(12.979f, 9.012f, 12.906f, 9.013f, 12.708f, 9.015f)
                curveTo(12.68f, 9.015f, 12.651f, 9.016f, 12.618f, 9.016f)
                curveTo(12.354f, 9.016f, 11.848f, 9.14f, 11.696f, 9.285f)
                curveTo(11.545f, 9.43f, 11.387f, 9.461f, 11.153f, 9.461f)
                curveTo(10.92f, 9.461f, 11.064f, 9.618f, 11.276f, 9.724f)
                curveTo(11.048f, 9.767f, 10.901f, 10.148f, 10.815f, 10.486f)
                curveTo(10.768f, 10.148f, 10.665f, 9.767f, 10.436f, 9.724f)
                curveTo(10.649f, 9.618f, 10.792f, 9.461f, 10.559f, 9.461f)
                curveTo(10.326f, 9.461f, 10.167f, 9.43f, 10.016f, 9.285f)
                curveTo(9.865f, 9.14f, 9.359f, 9.016f, 9.094f, 9.016f)
                curveTo(9.062f, 9.016f, 9.032f, 9.015f, 9.005f, 9.015f)
                curveTo(8.806f, 9.013f, 8.734f, 9.012f, 8.829f, 9.14f)
                curveTo(8.859f, 9.18f, 8.916f, 9.242f, 8.985f, 9.316f)
                curveTo(9.163f, 9.508f, 9.42f, 9.785f, 9.494f, 10f)
                curveTo(9.544f, 10.146f, 9.553f, 10.21f, 9.561f, 10.266f)
                curveTo(9.569f, 10.325f, 9.576f, 10.377f, 9.627f, 10.505f)
                curveTo(9.651f, 10.565f, 9.686f, 10.625f, 9.722f, 10.686f)
                curveTo(9.839f, 10.886f, 9.964f, 11.101f, 9.727f, 11.356f)
                curveTo(9.602f, 11.492f, 9.478f, 11.655f, 9.367f, 11.802f)
                curveTo(9.206f, 12.015f, 9.072f, 12.192f, 9f, 12.192f)
                horizontalLineTo(8.829f)
                curveTo(8.829f, 12.192f, 7.301f, 10.465f, 7.501f, 10f)
                curveTo(7.578f, 9.82f, 7.702f, 9.651f, 7.805f, 9.511f)
                curveTo(7.968f, 9.289f, 8.077f, 9.14f, 7.858f, 9.14f)
                curveTo(7.501f, 9.14f, 6.076f, 10.043f, 6.076f, 12.08f)
                curveTo(6.076f, 14.118f, 6.207f, 15.276f, 6.513f, 16.088f)
                curveTo(6.721f, 16.642f, 6.53f, 17.18f, 6.388f, 17.581f)
                curveTo(6.322f, 17.767f, 6.266f, 17.924f, 6.266f, 18.039f)
                curveTo(6.266f, 18.402f, 6.827f, 18.084f, 6.827f, 17.857f)
                curveTo(6.827f, 17.75f, 6.904f, 17.91f, 6.985f, 18.079f)
                curveTo(7.073f, 18.264f, 7.167f, 18.46f, 7.167f, 18.315f)
                curveTo(7.167f, 18.161f, 7.256f, 17.998f, 7.335f, 17.854f)
                curveTo(7.397f, 17.741f, 7.453f, 17.64f, 7.453f, 17.565f)
                curveTo(7.453f, 17.49f, 7.531f, 17.493f, 7.619f, 17.496f)
                curveTo(7.731f, 17.5f, 7.858f, 17.504f, 7.858f, 17.35f)
                curveTo(7.858f, 17.246f, 7.898f, 17.225f, 7.949f, 17.199f)
                curveTo(8.032f, 17.156f, 8.142f, 17.1f, 8.142f, 16.633f)
                curveTo(8.142f, 16.287f, 8.211f, 16.41f, 8.29f, 16.55f)
                curveTo(8.363f, 16.68f, 8.445f, 16.824f, 8.49f, 16.633f)
                curveTo(8.494f, 16.615f, 8.54f, 16.534f, 8.596f, 16.435f)
                curveTo(8.679f, 16.291f, 8.785f, 16.106f, 8.818f, 16.013f)
                curveTo(8.714f, 16.421f, 8.465f, 16.845f, 8.306f, 17.048f)
                curveTo(8.142f, 17.257f, 7.858f, 17.712f, 7.858f, 17.712f)
                curveTo(7.858f, 17.712f, 8.122f, 17.86f, 8.306f, 17.712f)
                curveTo(8.408f, 17.63f, 8.415f, 17.708f, 8.423f, 17.792f)
                curveTo(8.429f, 17.859f, 8.435f, 17.93f, 8.49f, 17.93f)
                curveTo(8.524f, 17.93f, 8.556f, 17.935f, 8.584f, 17.941f)
                curveTo(8.605f, 17.944f, 8.625f, 17.948f, 8.641f, 17.948f)
                curveTo(8.58f, 18.104f, 8.525f, 18.354f, 8.709f, 18.187f)
                curveTo(8.841f, 18.068f, 8.933f, 18.019f, 8.994f, 17.987f)
                curveTo(9.065f, 17.95f, 9.094f, 17.935f, 9.094f, 17.857f)
                curveTo(9.094f, 17.78f, 9.123f, 17.806f, 9.168f, 17.847f)
                curveTo(9.207f, 17.883f, 9.258f, 17.93f, 9.314f, 17.93f)
                curveTo(9.385f, 17.93f, 9.4f, 17.83f, 9.422f, 17.686f)
                curveTo(9.436f, 17.589f, 9.454f, 17.471f, 9.494f, 17.35f)
                curveTo(9.503f, 17.322f, 9.511f, 17.294f, 9.52f, 17.269f)
                curveTo(9.6f, 17.019f, 9.637f, 16.902f, 9.727f, 17.218f)
                curveTo(9.77f, 17.365f, 9.845f, 17.469f, 9.91f, 17.56f)
                curveTo(9.999f, 17.683f, 10.069f, 17.782f, 10.016f, 17.93f)
                curveTo(9.995f, 17.988f, 9.969f, 18.053f, 9.941f, 18.124f)
                curveTo(9.845f, 18.364f, 9.727f, 18.659f, 9.727f, 18.892f)
                curveTo(9.727f, 19.03f, 9.602f, 19.218f, 9.484f, 19.395f)
                curveTo(9.345f, 19.603f, 9.217f, 19.794f, 9.314f, 19.872f)
                curveTo(9.494f, 20.015f, 9.276f, 20.497f, 9.094f, 20.744f)
                curveTo(8.912f, 20.992f, 8.942f, 21.294f, 9.218f, 21.294f)
                curveTo(9.369f, 21.294f, 9.451f, 21.349f, 9.525f, 21.398f)
                curveTo(9.586f, 21.439f, 9.642f, 21.477f, 9.727f, 21.477f)
                curveTo(9.916f, 21.477f, 10.016f, 21.384f, 10.016f, 21.384f)
                curveTo(10.016f, 21.384f, 10.133f, 21.56f, 10.326f, 21.56f)
                curveTo(10.52f, 21.56f, 10.559f, 21.384f, 10.559f, 21.384f)
                lineTo(10.702f, 21.56f)
                lineTo(10.714f, 20.789f)
                verticalLineTo(21.56f)
                lineTo(11.153f, 21.384f)
                curveTo(11.153f, 21.384f, 11.193f, 21.56f, 11.387f, 21.56f)
                curveTo(11.58f, 21.56f, 11.696f, 21.384f, 11.696f, 21.384f)
                curveTo(11.696f, 21.384f, 11.797f, 21.477f, 11.985f, 21.477f)
                curveTo(12.071f, 21.477f, 12.127f, 21.439f, 12.188f, 21.398f)
                curveTo(12.262f, 21.349f, 12.344f, 21.294f, 12.495f, 21.294f)
                curveTo(12.77f, 21.294f, 12.8f, 20.992f, 12.618f, 20.744f)
                curveTo(12.437f, 20.497f, 12.219f, 20.015f, 12.399f, 19.872f)
                curveTo(12.496f, 19.794f, 12.368f, 19.603f, 12.229f, 19.395f)
                curveTo(12.111f, 19.218f, 11.985f, 19.03f, 11.985f, 18.892f)
                curveTo(11.985f, 18.659f, 11.867f, 18.364f, 11.771f, 18.124f)
                curveTo(11.743f, 18.053f, 11.717f, 17.988f, 11.696f, 17.93f)
                curveTo(11.643f, 17.782f, 11.714f, 17.683f, 11.803f, 17.56f)
                curveTo(11.868f, 17.469f, 11.943f, 17.365f, 11.985f, 17.218f)
                curveTo(12.076f, 16.902f, 12.113f, 17.019f, 12.193f, 17.269f)
                curveTo(12.201f, 17.294f, 12.21f, 17.322f, 12.219f, 17.35f)
                curveTo(12.259f, 17.471f, 12.276f, 17.589f, 12.291f, 17.686f)
                curveTo(12.313f, 17.83f, 12.327f, 17.93f, 12.399f, 17.93f)
                curveTo(12.454f, 17.93f, 12.506f, 17.883f, 12.545f, 17.847f)
                curveTo(12.59f, 17.806f, 12.618f, 17.78f, 12.618f, 17.857f)
                curveTo(12.618f, 17.935f, 12.648f, 17.95f, 12.718f, 17.987f)
                curveTo(12.78f, 18.019f, 12.872f, 18.068f, 13.003f, 18.187f)
                curveTo(13.188f, 18.354f, 13.133f, 18.104f, 13.071f, 17.948f)
                curveTo(13.088f, 17.948f, 13.107f, 17.944f, 13.128f, 17.941f)
                curveTo(13.157f, 17.935f, 13.189f, 17.93f, 13.223f, 17.93f)
                curveTo(13.277f, 17.93f, 13.284f, 17.859f, 13.29f, 17.792f)
                curveTo(13.297f, 17.708f, 13.304f, 17.63f, 13.407f, 17.712f)
                curveTo(13.59f, 17.86f, 13.855f, 17.712f, 13.855f, 17.712f)
                curveTo(13.855f, 17.712f, 13.571f, 17.257f, 13.407f, 17.048f)
                curveTo(13.248f, 16.845f, 12.998f, 16.421f, 12.894f, 16.013f)
                curveTo(12.928f, 16.106f, 13.034f, 16.291f, 13.116f, 16.435f)
                curveTo(13.173f, 16.534f, 13.219f, 16.615f, 13.223f, 16.633f)
                curveTo(13.267f, 16.824f, 13.349f, 16.68f, 13.422f, 16.55f)
                curveTo(13.502f, 16.41f, 13.571f, 16.287f, 13.571f, 16.633f)
                curveTo(13.571f, 17.1f, 13.681f, 17.156f, 13.764f, 17.199f)
                curveTo(13.814f, 17.225f, 13.855f, 17.246f, 13.855f, 17.35f)
                curveTo(13.855f, 17.504f, 13.981f, 17.5f, 14.093f, 17.496f)
                curveTo(14.181f, 17.493f, 14.26f, 17.49f, 14.26f, 17.565f)
                curveTo(14.26f, 17.64f, 14.316f, 17.741f, 14.378f, 17.854f)
                curveTo(14.456f, 17.998f, 14.546f, 18.161f, 14.546f, 18.315f)
                curveTo(14.546f, 18.46f, 14.639f, 18.264f, 14.728f, 18.079f)
                curveTo(14.809f, 17.91f, 14.885f, 17.75f, 14.885f, 17.857f)
                curveTo(14.885f, 18.084f, 15.446f, 18.402f, 15.446f, 18.039f)
                curveTo(15.446f, 17.924f, 15.391f, 17.767f, 15.325f, 17.581f)
                curveTo(15.182f, 17.18f, 14.991f, 16.642f, 15.2f, 16.088f)
                curveTo(15.505f, 15.276f, 15.637f, 14.118f, 15.637f, 12.08f)
                curveTo(15.637f, 10.043f, 14.212f, 9.14f, 13.855f, 9.14f)
                curveTo(13.635f, 9.14f, 13.745f, 9.289f, 13.908f, 9.511f)
                curveTo(14.011f, 9.651f, 14.135f, 9.82f, 14.212f, 10f)
                close()
                moveTo(12.883f, 15.968f)
                curveTo(12.887f, 15.983f, 12.891f, 15.998f, 12.894f, 16.013f)
                curveTo(12.887f, 15.994f, 12.883f, 15.979f, 12.883f, 15.968f)
                close()
                moveTo(13.003f, 17.857f)
                curveTo(13.003f, 17.807f, 13.038f, 17.864f, 13.071f, 17.948f)
                curveTo(13.029f, 17.949f, 13.003f, 17.932f, 13.003f, 17.857f)
                close()
                moveTo(8.641f, 17.948f)
                curveTo(8.683f, 17.949f, 8.709f, 17.932f, 8.709f, 17.857f)
                curveTo(8.709f, 17.807f, 8.674f, 17.864f, 8.641f, 17.948f)
                close()
                moveTo(8.818f, 16.013f)
                curveTo(8.825f, 15.994f, 8.829f, 15.979f, 8.829f, 15.968f)
                curveTo(8.826f, 15.983f, 8.822f, 15.998f, 8.818f, 16.013f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.189f, 19.202f)
                curveTo(8.189f, 19.061f, 8.548f, 18.735f, 8.548f, 18.735f)
                verticalLineTo(18.763f)
                curveTo(8.599f, 18.804f, 8.92f, 19.069f, 8.92f, 19.198f)
                curveTo(8.92f, 19.279f, 8.879f, 19.395f, 8.843f, 19.495f)
                curveTo(8.816f, 19.57f, 8.793f, 19.635f, 8.793f, 19.669f)
                curveTo(8.793f, 19.691f, 8.802f, 19.675f, 8.82f, 19.644f)
                curveTo(8.865f, 19.567f, 8.961f, 19.401f, 9.096f, 19.512f)
                curveTo(9.275f, 19.66f, 9.274f, 19.877f, 9.273f, 20.015f)
                curveTo(9.273f, 20.023f, 9.273f, 20.031f, 9.273f, 20.039f)
                curveTo(9.273f, 20.082f, 9.273f, 20.082f, 9.267f, 20.061f)
                curveTo(9.255f, 20.017f, 9.216f, 19.879f, 9.096f, 19.879f)
                curveTo(8.92f, 19.879f, 8.793f, 20.039f, 8.793f, 20.039f)
                verticalLineTo(20.311f)
                curveTo(8.793f, 20.311f, 8.815f, 20.536f, 8.92f, 20.423f)
                curveTo(9.025f, 20.311f, 9.047f, 20.562f, 8.92f, 20.562f)
                curveTo(8.855f, 20.562f, 8.788f, 20.631f, 8.723f, 20.698f)
                curveTo(8.66f, 20.763f, 8.599f, 20.826f, 8.542f, 20.826f)
                verticalLineTo(20.804f)
                curveTo(8.488f, 20.799f, 8.443f, 20.744f, 8.397f, 20.687f)
                curveTo(8.348f, 20.625f, 8.297f, 20.562f, 8.232f, 20.562f)
                curveTo(8.105f, 20.562f, 8.128f, 20.311f, 8.232f, 20.423f)
                curveTo(8.337f, 20.536f, 8.36f, 20.311f, 8.36f, 20.311f)
                verticalLineTo(20.039f)
                curveTo(8.36f, 20.039f, 8.232f, 19.879f, 8.056f, 19.879f)
                curveTo(7.936f, 19.879f, 7.898f, 20.017f, 7.885f, 20.061f)
                curveTo(7.88f, 20.082f, 7.88f, 20.082f, 7.88f, 20.039f)
                curveTo(7.88f, 20.031f, 7.88f, 20.023f, 7.88f, 20.015f)
                curveTo(7.879f, 19.877f, 7.878f, 19.66f, 8.056f, 19.512f)
                curveTo(8.191f, 19.401f, 8.288f, 19.567f, 8.332f, 19.644f)
                curveTo(8.35f, 19.675f, 8.36f, 19.691f, 8.36f, 19.669f)
                curveTo(8.36f, 19.635f, 8.328f, 19.57f, 8.293f, 19.496f)
                curveTo(8.245f, 19.398f, 8.189f, 19.282f, 8.189f, 19.202f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.971f, 19.202f)
                curveTo(12.971f, 19.061f, 13.331f, 18.735f, 13.331f, 18.735f)
                verticalLineTo(18.763f)
                curveTo(13.381f, 18.804f, 13.703f, 19.069f, 13.703f, 19.198f)
                curveTo(13.703f, 19.279f, 13.661f, 19.395f, 13.625f, 19.495f)
                curveTo(13.599f, 19.57f, 13.575f, 19.635f, 13.575f, 19.669f)
                curveTo(13.575f, 19.691f, 13.585f, 19.675f, 13.603f, 19.644f)
                curveTo(13.647f, 19.567f, 13.744f, 19.401f, 13.879f, 19.512f)
                curveTo(14.057f, 19.66f, 14.056f, 19.877f, 14.056f, 20.015f)
                curveTo(14.056f, 20.023f, 14.055f, 20.031f, 14.055f, 20.039f)
                curveTo(14.055f, 20.082f, 14.055f, 20.082f, 14.05f, 20.061f)
                curveTo(14.037f, 20.017f, 13.999f, 19.879f, 13.879f, 19.879f)
                curveTo(13.703f, 19.879f, 13.575f, 20.039f, 13.575f, 20.039f)
                verticalLineTo(20.311f)
                curveTo(13.575f, 20.311f, 13.598f, 20.536f, 13.703f, 20.423f)
                curveTo(13.808f, 20.311f, 13.83f, 20.562f, 13.703f, 20.562f)
                curveTo(13.638f, 20.562f, 13.571f, 20.631f, 13.506f, 20.698f)
                curveTo(13.443f, 20.763f, 13.382f, 20.826f, 13.324f, 20.826f)
                verticalLineTo(20.804f)
                curveTo(13.27f, 20.799f, 13.225f, 20.744f, 13.18f, 20.687f)
                curveTo(13.13f, 20.625f, 13.08f, 20.562f, 13.015f, 20.562f)
                curveTo(12.888f, 20.562f, 12.91f, 20.311f, 13.015f, 20.423f)
                curveTo(13.12f, 20.536f, 13.142f, 20.311f, 13.142f, 20.311f)
                verticalLineTo(20.039f)
                curveTo(13.142f, 20.039f, 13.015f, 19.879f, 12.839f, 19.879f)
                curveTo(12.719f, 19.879f, 12.68f, 20.017f, 12.668f, 20.061f)
                curveTo(12.662f, 20.082f, 12.662f, 20.082f, 12.662f, 20.039f)
                curveTo(12.662f, 20.031f, 12.662f, 20.023f, 12.662f, 20.015f)
                curveTo(12.661f, 19.877f, 12.66f, 19.66f, 12.839f, 19.512f)
                curveTo(12.974f, 19.401f, 13.071f, 19.567f, 13.115f, 19.644f)
                curveTo(13.133f, 19.675f, 13.142f, 19.691f, 13.142f, 19.669f)
                curveTo(13.142f, 19.635f, 13.111f, 19.57f, 13.075f, 19.496f)
                curveTo(13.027f, 19.398f, 12.971f, 19.282f, 12.971f, 19.202f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.831f, 18.359f)
                curveTo(8.151f, 18.359f, 8.216f, 17.75f, 8.216f, 17.75f)
                curveTo(8.216f, 17.75f, 8.485f, 17.471f, 8.485f, 17.677f)
                curveTo(8.485f, 17.786f, 8.408f, 17.924f, 8.35f, 18.029f)
                curveTo(8.299f, 18.121f, 8.263f, 18.188f, 8.303f, 18.188f)
                horizontalLineTo(8.747f)
                curveTo(9.113f, 18.188f, 8.683f, 18.359f, 8.485f, 18.436f)
                curveTo(8.395f, 18.47f, 8.331f, 18.489f, 8.27f, 18.506f)
                curveTo(8.197f, 18.527f, 8.127f, 18.547f, 8.02f, 18.593f)
                curveTo(7.824f, 18.678f, 7.74f, 19.237f, 7.831f, 19.417f)
                curveTo(7.922f, 19.597f, 7.74f, 19.521f, 7.665f, 19.417f)
                curveTo(7.623f, 19.359f, 7.592f, 19.439f, 7.55f, 19.549f)
                curveTo(7.516f, 19.638f, 7.474f, 19.747f, 7.413f, 19.821f)
                curveTo(7.294f, 19.965f, 7.296f, 19.838f, 7.298f, 19.564f)
                curveTo(7.299f, 19.519f, 7.299f, 19.469f, 7.299f, 19.417f)
                curveTo(7.299f, 19.174f, 7.348f, 19.172f, 7.42f, 19.169f)
                curveTo(7.458f, 19.167f, 7.503f, 19.165f, 7.551f, 19.127f)
                curveTo(7.654f, 19.044f, 7.667f, 19.001f, 7.698f, 18.894f)
                curveTo(7.708f, 18.858f, 7.721f, 18.814f, 7.74f, 18.759f)
                curveTo(7.815f, 18.542f, 7.413f, 18.886f, 7.299f, 19.049f)
                curveTo(7.23f, 19.148f, 7.182f, 19.159f, 7.11f, 19.175f)
                curveTo(7.064f, 19.185f, 7.008f, 19.198f, 6.93f, 19.237f)
                curveTo(6.803f, 19.302f, 6.838f, 19.175f, 6.88f, 19.021f)
                curveTo(6.904f, 18.933f, 6.93f, 18.835f, 6.93f, 18.759f)
                curveTo(6.93f, 18.629f, 7.009f, 18.662f, 7.109f, 18.705f)
                curveTo(7.169f, 18.731f, 7.236f, 18.759f, 7.299f, 18.759f)
                curveTo(7.461f, 18.759f, 7.545f, 18.691f, 7.648f, 18.607f)
                curveTo(7.654f, 18.602f, 7.659f, 18.598f, 7.665f, 18.593f)
                curveTo(7.747f, 18.526f, 7.567f, 18.546f, 7.352f, 18.57f)
                curveTo(7.279f, 18.579f, 7.201f, 18.587f, 7.129f, 18.593f)
                curveTo(6.964f, 18.607f, 6.953f, 18.597f, 6.912f, 18.559f)
                curveTo(6.882f, 18.533f, 6.837f, 18.492f, 6.707f, 18.436f)
                curveTo(6.398f, 18.301f, 6.906f, 18.359f, 7.129f, 18.436f)
                curveTo(7.253f, 18.478f, 7.357f, 18.45f, 7.48f, 18.416f)
                curveTo(7.578f, 18.389f, 7.688f, 18.359f, 7.831f, 18.359f)
                close()
                moveTo(14.046f, 18.359f)
                curveTo(13.725f, 18.359f, 13.66f, 17.75f, 13.66f, 17.75f)
                curveTo(13.66f, 17.75f, 13.392f, 17.471f, 13.392f, 17.677f)
                curveTo(13.392f, 17.786f, 13.468f, 17.924f, 13.526f, 18.029f)
                curveTo(13.577f, 18.121f, 13.614f, 18.188f, 13.573f, 18.188f)
                horizontalLineTo(13.129f)
                curveTo(12.764f, 18.188f, 13.194f, 18.359f, 13.392f, 18.436f)
                curveTo(13.481f, 18.47f, 13.545f, 18.489f, 13.606f, 18.506f)
                curveTo(13.679f, 18.527f, 13.749f, 18.547f, 13.856f, 18.593f)
                curveTo(14.052f, 18.678f, 14.137f, 19.237f, 14.046f, 19.417f)
                curveTo(13.955f, 19.597f, 14.137f, 19.521f, 14.212f, 19.417f)
                curveTo(14.253f, 19.359f, 14.284f, 19.439f, 14.326f, 19.549f)
                curveTo(14.36f, 19.638f, 14.402f, 19.747f, 14.463f, 19.821f)
                curveTo(14.582f, 19.965f, 14.581f, 19.838f, 14.578f, 19.564f)
                curveTo(14.577f, 19.519f, 14.577f, 19.469f, 14.577f, 19.417f)
                curveTo(14.577f, 19.174f, 14.528f, 19.172f, 14.456f, 19.169f)
                curveTo(14.418f, 19.167f, 14.373f, 19.165f, 14.325f, 19.127f)
                curveTo(14.222f, 19.044f, 14.21f, 19.001f, 14.179f, 18.894f)
                curveTo(14.168f, 18.858f, 14.155f, 18.814f, 14.137f, 18.759f)
                curveTo(14.061f, 18.542f, 14.463f, 18.886f, 14.577f, 19.049f)
                curveTo(14.646f, 19.148f, 14.694f, 19.159f, 14.766f, 19.175f)
                curveTo(14.813f, 19.185f, 14.869f, 19.198f, 14.946f, 19.237f)
                curveTo(15.073f, 19.302f, 15.039f, 19.175f, 14.997f, 19.021f)
                curveTo(14.973f, 18.933f, 14.946f, 18.835f, 14.946f, 18.759f)
                curveTo(14.946f, 18.629f, 14.868f, 18.662f, 14.767f, 18.705f)
                curveTo(14.708f, 18.731f, 14.64f, 18.759f, 14.577f, 18.759f)
                curveTo(14.415f, 18.759f, 14.332f, 18.691f, 14.228f, 18.607f)
                curveTo(14.223f, 18.602f, 14.217f, 18.598f, 14.212f, 18.593f)
                curveTo(14.129f, 18.526f, 14.309f, 18.546f, 14.524f, 18.57f)
                curveTo(14.597f, 18.579f, 14.675f, 18.587f, 14.747f, 18.593f)
                curveTo(14.913f, 18.607f, 14.924f, 18.597f, 14.965f, 18.559f)
                curveTo(14.995f, 18.533f, 15.04f, 18.492f, 15.169f, 18.436f)
                curveTo(15.479f, 18.301f, 14.97f, 18.359f, 14.747f, 18.436f)
                curveTo(14.623f, 18.478f, 14.519f, 18.45f, 14.396f, 18.416f)
                curveTo(14.298f, 18.389f, 14.188f, 18.359f, 14.046f, 18.359f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.047f, 12.341f)
                horizontalLineTo(12.923f)
                verticalLineTo(15.875f)
                curveTo(12.923f, 15.875f, 12.507f, 17.636f, 10.985f, 17.636f)
                curveTo(9.463f, 17.636f, 9.047f, 15.875f, 9.047f, 15.875f)
                verticalLineTo(12.341f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.507f, 12.29f)
                horizontalLineTo(10.493f)
                verticalLineTo(14.319f)
                horizontalLineTo(9.044f)
                verticalLineTo(15.043f)
                horizontalLineTo(10.493f)
                verticalLineTo(17.652f)
                horizontalLineTo(11.507f)
                verticalLineTo(15.043f)
                horizontalLineTo(12.957f)
                verticalLineTo(14.319f)
                horizontalLineTo(11.507f)
                verticalLineTo(12.29f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.701f, 13.309f)
                curveTo(9.798f, 13.309f, 9.845f, 13.227f, 9.793f, 13.155f)
                curveTo(9.766f, 13.117f, 9.71f, 13.106f, 9.668f, 13.13f)
                curveTo(9.664f, 13.132f, 9.661f, 13.135f, 9.657f, 13.137f)
                curveTo(9.642f, 13.133f, 9.623f, 13.128f, 9.601f, 13.121f)
                curveTo(9.581f, 13.115f, 9.56f, 13.116f, 9.541f, 13.122f)
                curveTo(9.517f, 13.13f, 9.504f, 13.106f, 9.515f, 12.956f)
                curveTo(9.526f, 12.914f, 9.583f, 12.888f, 9.717f, 12.888f)
                curveTo(9.961f, 12.888f, 10.061f, 12.914f, 10.061f, 12.937f)
                verticalLineTo(13.296f)
                lineTo(9.943f, 13.403f)
                curveTo(9.886f, 13.454f, 9.926f, 13.542f, 10.007f, 13.542f)
                horizontalLineTo(10.061f)
                verticalLineTo(13.817f)
                curveTo(9.987f, 13.875f, 9.92f, 13.902f, 9.862f, 13.902f)
                curveTo(9.644f, 13.902f, 9.521f, 13.82f, 9.518f, 13.724f)
                curveTo(9.519f, 13.696f, 9.52f, 13.675f, 9.521f, 13.661f)
                curveTo(9.526f, 13.663f, 9.533f, 13.665f, 9.54f, 13.667f)
                curveTo(9.559f, 13.674f, 9.582f, 13.675f, 9.602f, 13.668f)
                lineTo(9.61f, 13.666f)
                curveTo(9.618f, 13.663f, 9.622f, 13.661f, 9.625f, 13.663f)
                curveTo(9.628f, 13.665f, 9.628f, 13.674f, 9.627f, 13.693f)
                lineTo(9.627f, 13.693f)
                lineTo(9.627f, 13.693f)
                curveTo(9.627f, 13.701f, 9.627f, 13.71f, 9.626f, 13.72f)
                curveTo(9.625f, 13.765f, 9.665f, 13.803f, 9.715f, 13.804f)
                curveTo(9.765f, 13.805f, 9.806f, 13.769f, 9.807f, 13.724f)
                curveTo(9.811f, 13.565f, 9.722f, 13.474f, 9.575f, 13.505f)
                curveTo(9.488f, 13.479f, 9.427f, 13.482f, 9.38f, 13.536f)
                curveTo(9.345f, 13.575f, 9.34f, 13.608f, 9.337f, 13.724f)
                curveTo(9.343f, 13.925f, 9.555f, 14.065f, 9.862f, 14.065f)
                curveTo(9.98f, 14.065f, 10.097f, 14.012f, 10.214f, 13.912f)
                curveTo(10.232f, 13.896f, 10.242f, 13.875f, 10.242f, 13.853f)
                verticalLineTo(13.46f)
                curveTo(10.242f, 13.434f, 10.228f, 13.41f, 10.207f, 13.396f)
                lineTo(10.216f, 13.387f)
                curveTo(10.233f, 13.372f, 10.242f, 13.351f, 10.242f, 13.33f)
                verticalLineTo(12.937f)
                curveTo(10.242f, 12.77f, 10.069f, 12.725f, 9.717f, 12.725f)
                curveTo(9.509f, 12.725f, 9.373f, 12.786f, 9.337f, 12.931f)
                curveTo(9.316f, 13.179f, 9.39f, 13.327f, 9.571f, 13.285f)
                curveTo(9.627f, 13.301f, 9.669f, 13.309f, 9.701f, 13.309f)
                close()
                moveTo(12.246f, 13.155f)
                curveTo(12.195f, 13.227f, 12.241f, 13.309f, 12.339f, 13.309f)
                curveTo(12.37f, 13.309f, 12.412f, 13.301f, 12.468f, 13.285f)
                curveTo(12.65f, 13.327f, 12.723f, 13.179f, 12.703f, 12.931f)
                curveTo(12.666f, 12.786f, 12.53f, 12.725f, 12.323f, 12.725f)
                curveTo(11.97f, 12.725f, 11.797f, 12.77f, 11.797f, 12.937f)
                verticalLineTo(13.33f)
                curveTo(11.797f, 13.351f, 11.807f, 13.372f, 11.824f, 13.387f)
                lineTo(11.833f, 13.396f)
                curveTo(11.811f, 13.41f, 11.797f, 13.434f, 11.797f, 13.46f)
                verticalLineTo(13.853f)
                curveTo(11.797f, 13.875f, 11.807f, 13.896f, 11.825f, 13.912f)
                curveTo(11.942f, 14.012f, 12.059f, 14.065f, 12.178f, 14.065f)
                curveTo(12.485f, 14.065f, 12.696f, 13.925f, 12.703f, 13.724f)
                curveTo(12.699f, 13.608f, 12.694f, 13.575f, 12.66f, 13.536f)
                curveTo(12.612f, 13.482f, 12.551f, 13.479f, 12.464f, 13.505f)
                curveTo(12.317f, 13.474f, 12.228f, 13.565f, 12.232f, 13.724f)
                curveTo(12.233f, 13.769f, 12.274f, 13.805f, 12.325f, 13.804f)
                curveTo(12.375f, 13.803f, 12.414f, 13.765f, 12.413f, 13.72f)
                curveTo(12.413f, 13.71f, 12.412f, 13.701f, 12.412f, 13.693f)
                curveTo(12.411f, 13.674f, 12.411f, 13.665f, 12.415f, 13.663f)
                curveTo(12.417f, 13.661f, 12.422f, 13.663f, 12.429f, 13.666f)
                lineTo(12.438f, 13.668f)
                curveTo(12.458f, 13.675f, 12.48f, 13.674f, 12.5f, 13.667f)
                curveTo(12.507f, 13.665f, 12.513f, 13.663f, 12.519f, 13.661f)
                curveTo(12.52f, 13.675f, 12.521f, 13.696f, 12.522f, 13.724f)
                curveTo(12.518f, 13.82f, 12.396f, 13.902f, 12.178f, 13.902f)
                curveTo(12.119f, 13.902f, 12.053f, 13.875f, 11.978f, 13.817f)
                verticalLineTo(13.542f)
                horizontalLineTo(12.033f)
                curveTo(12.113f, 13.542f, 12.154f, 13.454f, 12.097f, 13.403f)
                lineTo(11.978f, 13.296f)
                verticalLineTo(12.937f)
                curveTo(11.978f, 12.914f, 12.078f, 12.888f, 12.323f, 12.888f)
                curveTo(12.456f, 12.888f, 12.513f, 12.914f, 12.524f, 12.956f)
                curveTo(12.535f, 13.106f, 12.522f, 13.13f, 12.499f, 13.122f)
                curveTo(12.479f, 13.116f, 12.458f, 13.115f, 12.438f, 13.121f)
                curveTo(12.417f, 13.128f, 12.398f, 13.133f, 12.382f, 13.137f)
                curveTo(12.379f, 13.135f, 12.375f, 13.132f, 12.372f, 13.13f)
                curveTo(12.329f, 13.106f, 12.273f, 13.117f, 12.246f, 13.155f)
                close()
                moveTo(12.552f, 13.654f)
                lineTo(12.548f, 13.654f)
                lineTo(12.55f, 13.654f)
                lineTo(12.552f, 13.654f)
                close()
                moveTo(12.339f, 15.918f)
                curveTo(12.241f, 15.918f, 12.195f, 15.835f, 12.246f, 15.763f)
                curveTo(12.273f, 15.725f, 12.329f, 15.714f, 12.372f, 15.739f)
                curveTo(12.375f, 15.741f, 12.379f, 15.743f, 12.382f, 15.746f)
                curveTo(12.398f, 15.742f, 12.417f, 15.737f, 12.438f, 15.73f)
                curveTo(12.458f, 15.724f, 12.479f, 15.724f, 12.499f, 15.731f)
                curveTo(12.522f, 15.738f, 12.535f, 15.714f, 12.524f, 15.564f)
                curveTo(12.513f, 15.523f, 12.456f, 15.497f, 12.323f, 15.497f)
                curveTo(12.078f, 15.497f, 11.978f, 15.523f, 11.978f, 15.546f)
                verticalLineTo(15.904f)
                lineTo(12.097f, 16.011f)
                curveTo(12.154f, 16.063f, 12.113f, 16.151f, 12.033f, 16.151f)
                horizontalLineTo(11.978f)
                verticalLineTo(16.425f)
                curveTo(12.053f, 16.483f, 12.119f, 16.51f, 12.178f, 16.51f)
                curveTo(12.396f, 16.51f, 12.518f, 16.429f, 12.522f, 16.333f)
                curveTo(12.521f, 16.305f, 12.52f, 16.284f, 12.519f, 16.27f)
                curveTo(12.513f, 16.272f, 12.507f, 16.274f, 12.5f, 16.276f)
                curveTo(12.48f, 16.283f, 12.458f, 16.283f, 12.438f, 16.277f)
                lineTo(12.429f, 16.274f)
                curveTo(12.422f, 16.272f, 12.417f, 16.27f, 12.415f, 16.272f)
                curveTo(12.411f, 16.274f, 12.411f, 16.282f, 12.412f, 16.302f)
                curveTo(12.412f, 16.309f, 12.413f, 16.318f, 12.413f, 16.329f)
                curveTo(12.414f, 16.374f, 12.375f, 16.411f, 12.325f, 16.412f)
                curveTo(12.274f, 16.413f, 12.233f, 16.378f, 12.232f, 16.332f)
                curveTo(12.228f, 16.174f, 12.317f, 16.083f, 12.464f, 16.114f)
                curveTo(12.551f, 16.088f, 12.612f, 16.091f, 12.66f, 16.145f)
                curveTo(12.694f, 16.184f, 12.699f, 16.216f, 12.703f, 16.333f)
                curveTo(12.696f, 16.534f, 12.485f, 16.674f, 12.178f, 16.674f)
                curveTo(12.059f, 16.674f, 11.942f, 16.621f, 11.825f, 16.521f)
                curveTo(11.807f, 16.505f, 11.797f, 16.484f, 11.797f, 16.461f)
                verticalLineTo(16.069f)
                curveTo(11.797f, 16.043f, 11.811f, 16.019f, 11.833f, 16.004f)
                lineTo(11.824f, 15.996f)
                curveTo(11.807f, 15.981f, 11.797f, 15.96f, 11.797f, 15.938f)
                verticalLineTo(15.546f)
                curveTo(11.797f, 15.378f, 11.97f, 15.333f, 12.323f, 15.333f)
                curveTo(12.53f, 15.333f, 12.666f, 15.395f, 12.703f, 15.54f)
                curveTo(12.723f, 15.788f, 12.65f, 15.936f, 12.468f, 15.893f)
                curveTo(12.412f, 15.909f, 12.37f, 15.918f, 12.339f, 15.918f)
                close()
                moveTo(9.701f, 15.918f)
                curveTo(9.798f, 15.918f, 9.845f, 15.835f, 9.793f, 15.763f)
                curveTo(9.766f, 15.725f, 9.71f, 15.714f, 9.668f, 15.739f)
                curveTo(9.664f, 15.741f, 9.661f, 15.743f, 9.657f, 15.746f)
                curveTo(9.642f, 15.742f, 9.623f, 15.737f, 9.601f, 15.73f)
                curveTo(9.581f, 15.724f, 9.56f, 15.724f, 9.541f, 15.731f)
                curveTo(9.517f, 15.738f, 9.504f, 15.714f, 9.515f, 15.564f)
                curveTo(9.526f, 15.523f, 9.583f, 15.497f, 9.717f, 15.497f)
                curveTo(9.961f, 15.497f, 10.061f, 15.523f, 10.061f, 15.546f)
                verticalLineTo(15.904f)
                lineTo(9.943f, 16.011f)
                curveTo(9.886f, 16.063f, 9.926f, 16.151f, 10.007f, 16.151f)
                horizontalLineTo(10.061f)
                verticalLineTo(16.425f)
                curveTo(9.987f, 16.483f, 9.92f, 16.51f, 9.862f, 16.51f)
                curveTo(9.644f, 16.51f, 9.521f, 16.429f, 9.518f, 16.333f)
                curveTo(9.519f, 16.305f, 9.52f, 16.284f, 9.521f, 16.27f)
                curveTo(9.526f, 16.272f, 9.533f, 16.274f, 9.54f, 16.276f)
                curveTo(9.559f, 16.283f, 9.582f, 16.283f, 9.602f, 16.277f)
                curveTo(9.605f, 16.276f, 9.608f, 16.275f, 9.61f, 16.274f)
                curveTo(9.618f, 16.272f, 9.622f, 16.27f, 9.625f, 16.272f)
                curveTo(9.628f, 16.274f, 9.628f, 16.282f, 9.627f, 16.302f)
                curveTo(9.627f, 16.309f, 9.627f, 16.318f, 9.626f, 16.329f)
                curveTo(9.625f, 16.374f, 9.665f, 16.411f, 9.715f, 16.412f)
                curveTo(9.765f, 16.413f, 9.806f, 16.378f, 9.807f, 16.332f)
                curveTo(9.811f, 16.174f, 9.722f, 16.083f, 9.575f, 16.114f)
                curveTo(9.488f, 16.088f, 9.427f, 16.091f, 9.38f, 16.145f)
                curveTo(9.345f, 16.184f, 9.34f, 16.216f, 9.337f, 16.333f)
                curveTo(9.343f, 16.534f, 9.555f, 16.674f, 9.862f, 16.674f)
                curveTo(9.98f, 16.674f, 10.097f, 16.621f, 10.214f, 16.521f)
                curveTo(10.232f, 16.505f, 10.242f, 16.484f, 10.242f, 16.461f)
                verticalLineTo(16.069f)
                curveTo(10.242f, 16.043f, 10.228f, 16.019f, 10.207f, 16.004f)
                lineTo(10.216f, 15.996f)
                curveTo(10.233f, 15.981f, 10.242f, 15.96f, 10.242f, 15.938f)
                verticalLineTo(15.546f)
                curveTo(10.242f, 15.378f, 10.069f, 15.333f, 9.717f, 15.333f)
                curveTo(9.509f, 15.333f, 9.373f, 15.395f, 9.337f, 15.54f)
                curveTo(9.316f, 15.788f, 9.39f, 15.936f, 9.571f, 15.893f)
                curveTo(9.627f, 15.909f, 9.669f, 15.918f, 9.701f, 15.918f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun SerbiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.Serbia,
            contentDescription = "Serbia Flag"
        )
    }
}
